// Hardcoded-string audit (June 2026): FR source + hand-written EN.
export const EXTRA4 = {
 "fr": {
  "dr.title": "Vous avez une déclaration en cours",
  "dr.expiresIn": "Brouillon conservé encore {h} h",
  "dr.continue": "Continuer ma déclaration",
  "dr.delete": "Supprimer définitivement",
  "dr.deleteConfirm": "Supprimer définitivement ce brouillon ? Cette action est irréversible.",
  "dr.deleted": "Brouillon supprimé",
  "fa.goBack": "Retour",
  "fa.categoryRequired": "Choisissez une catégorie pour l'objet trouvé.",
  "fa.confirmTitle": "Confirmer votre décision",
  "fa.cancel": "Annuler",
  "fa.africaFree": "Publication gratuite en Afrique — offre de lancement Findloop, profitez-en !",
  "fa.planSubFree": "Choisissez la durée : votre annonce est publiée immédiatement, sans paiement.",
  "fa.free": "Gratuit",
  "fa.renewDiscountHint": "−50 % appliqué car vous renouvelez avant l'expiration.",
  "fa.africaPublished": "Annonce publiée gratuitement — offre de lancement Afrique !",
  "fa.prefillPrevious": "Reprendre les informations de ma précédente annonce dans cette catégorie",
  "fa.waitFinderDecision": "En attente de la décision du trouveur",
  "fa.claimApprovedShort": "Le trouveur a validé votre réclamation",
  "fa.claimUnlockedShort": "Coordonnées débloquées — consultez le suivi",
  "fa.claimRejectedShort": "Réclamation refusée par le trouveur",
  "fa.claimRejectedText": "Le trouveur estime que cet objet n'est pas le vôtre.",
  "fa.claimUnlockText": "Débloquez les coordonnées du trouveur pour organiser la restitution.",
  "fa.unlockFree": "Débloquer gratuitement — offre de lancement",
  "fa.unlockBtn": "Débloquer les coordonnées",
  "fa.twoPhotosError": "Ajoutez 2 photos de votre objet.",
  "fa.claimTitle": "C'est mon objet",
  "fa.claimSub": "Décrivez votre objet et ajoutez 2 photos. La personne qui l'a trouvé comparera avec son annonce.",
  "fa.checkInfo": "Vérifiez vos informations avant l'envoi : elles seront comparées à celles du trouveur.",
  "fa.lostDate": "Date de perte",
  "fa.lostPlace": "Lieu de perte",
  "fa.twoPhotos": "2 photos de votre objet",
  "ph.secured": "Photo sécurisée",
  "ph.securing": "Sécurisation de la photo…",
  "fa.ownerSafety3": "Si la photo présentée par le trouveur porte le filigrane Findloop, n'acceptez pas le rendez-vous. La photo doit être une image originale prise par le trouveur, sans filigrane.",
  "pub.changePhoto": "Changer la photo",
  "fa.phoneMissing": "Non renseigné",
  "fa.ownerSafety1": "Privilégiez une remise dans un lieu public ou chez un partenaire Findloop. Si la distance est grande, proposez plutôt un envoi postal.",
  "fa.ownerSafety2": "Lors de la remise, vérifiez la pièce d'identité du trouveur.",
  "fa.photoReviewTitle": "Un trouveur a envoyé une photo. Ressemble-t-elle à votre objet ?",
  "fa.photoLooksLike": "Oui, ça ressemble à mon objet",
  "fa.photoNotMine": "Non, ce n'est pas mon objet",
  "fa.photoNotMineConfirm": "Le suivi sera clôturé des deux côtés et votre annonce restera ouverte pour un nouveau trouveur.",
  "fa.photoLooksLikeDone": "Merci ! Le trouveur va comparer votre déclaration.",
  "fa.photoNotMineDone": "Signalement écarté. Votre annonce reste ouverte.",
  "fa.ownerPhotoHint": "Seule la photo du trouveur vous est montrée. Indiquez si elle ressemble à votre objet.",
  "fa.ownerReviewingPhoto": "Le propriétaire examine votre photo",
  "fa.ownerReviewingPhotoText": "Vous serez notifié dès qu'il aura répondu. Vous pourrez alors comparer sa déclaration.",
  "fa.ownerRejectedPhoto": "Ce n'est pas l'objet du propriétaire",
  "fa.ownerRejectedPhotoText": "Le propriétaire indique que votre photo ne correspond pas à son objet. Le suivi est clôturé. Merci pour votre aide !",
  "fa.contribute": "Contribuer",
  "fa.followupClosed": "Suivi clôturé",
  "fa.followupClosedText": "Vous avez clôturé ce suivi. Merci pour votre aide !",
  "fa.closeFollowup": "Clôturer ce suivi",
  "fa.closeFollowupConfirm": "Clôturer ce suivi ? Les emails et téléphones des deux parties seront supprimés définitivement dès que le propriétaire aura lui aussi clôturé son annonce.",
  "fa.safetyTitle": "Conseils de sécurité avant la remise",
  "fa.safety1": "Demandez au propriétaire une description détaillée de caractéristiques cachées de l'objet : rayure spécifique, contenu exact d'un sac, fond d'écran, numéro de série…",
  "fa.safety2": "Demandez si possible une preuve visuelle (photo de l'objet) ou une preuve d'achat.",
  "fa.safety3": "Faites la remise dans un lieu public ou chez un partenaire Findloop, en vérifiant la pièce d'identité du propriétaire.",
  "fa.safetyOk": "J'ai compris, continuer",
  "fa.ownerClosedNote": "Le propriétaire a clôturé son annonce.",
  "fa.finderClosedNote": "Le trouveur a clôturé son suivi.",
  "fa.claimSentFinder": "Réclamation envoyée à la personne qui a trouvé l'objet.",
  "fa.compareClaimHint": "Comparez la déclaration du propriétaire avec votre annonce avant de décider.",
  "fa.claimSubV2": "Décrivez votre objet perdu. La personne qui l'a trouvé comparera votre déclaration avec son annonce.",
  "fa.photosOptional": "Photos de votre objet (facultatif)",
  "fa.compareOwnerHint": "Comparez ces informations avec l'objet que vous avez trouvé, puis indiquez s'il s'agit bien du même objet.",
  "fa.itsThisItem": "Oui, c'est bien cet objet",
  "fa.notThisItem": "Non, ce n'est pas cet objet",
  "fa.confirmIsItem": "Confirmer qu'il s'agit bien de cet objet ? Vos coordonnées et celles du propriétaire seront affichées dans vos espaces respectifs.",
  "fa.confirmNotItem": "Confirmer que ce n'est pas cet objet ? Votre signalement sera clôturé.",
  "fa.youConfirmed": "Vous avez confirmé que c'est bien l'objet du propriétaire",
  "fa.youDeclined": "Vous avez indiqué que ce n'était pas cet objet",
  "fa.youDeclinedText": "Merci pour votre aide ! Le propriétaire a été informé.",
  "fa.waitFinderDecisionOwner": "En attente de la décision du trouveur",
  "fa.finderConfirmed": "Confirmé",
  "fa.notYourItem": "Ce n'était pas votre objet",
  "fa.reportedOn": "Signalé le",
  "fa.ownerWaitHint": "Un trouveur vérifie actuellement les informations, merci de patienter.",
  "fa.twoPhotosHint": "Photos personnelles prouvant que l'objet vous appartient (avec l'objet, facture, boîte…).",
  "fa.sendClaim": "Envoyer ma réclamation",
  "fa.colYourAd": "Votre annonce",
  "fa.colOwner": "Déclaration du propriétaire",
  "fa.approveClaimConfirm": "Valider cette réclamation ? Le propriétaire pourra ensuite débloquer vos coordonnées.",
  "fa.waitUnlockTitle": "En attente du déblocage par le propriétaire",
  "fa.waitUnlockText": "Vous serez notifié dès que les coordonnées seront échangées.",
  "fa.waitClaimantText": "Nous vous préviendrons dès qu'un propriétaire réclamera cet objet.",
  "fa.claimsTitle": "Réclamations de propriétaires",
  "fa.renewed": "Annonce renouvelée",
  "fa.renewTitle": "Renouveler mon annonce",
  "fa.renewDiscountBanner": "−50 % : renouvelez avant l'expiration de votre annonce !",
  "fa.renewBtn": "Renouveler",
  "fa.renewEarly": "Renouveler (−50 %)",
  "fa.noReceipt": "Aucun reçu disponible pour cette annonce.",
  "fa.expired": "Annonce expirée",
  "fa.receipt": "Reçu PDF",
  "fa.planTitle": "Durée de publication",
  "fa.planSub": "Votre annonce est publiée dès que le paiement est confirmé.",
  "fa.days7": "7 jours",
  "fa.days30": "30 jours",
  "fa.months3": "3 mois",
  "fa.hours24": "24 heures",
  "fa.days3": "3 jours",
  "fa.ht": "HT",
  "fa.ttc": "TTC",
  "fa.boostTitle": "Booster mon annonce (optionnel)",
  "fa.boostSub": "Votre annonce reste en tête de liste pendant la durée choisie.",
  "fa.noBoost": "Sans boost",
  "fa.total": "Total à payer",
  "fa.payPublish": "Payer et publier",
  "fa.redirectStripe": "Redirection vers le paiement sécurisé…",
  "fa.publicNote": "Seules la description, la ville, le pays et les photos seront visibles publiquement.",
  "fa.pendingPayTitle": "Paiement en attente",
  "fa.pendingPayText": "Votre annonce sera publiée dès que le paiement sera confirmé.",
  "fa.finishPay": "Finaliser le paiement",
  "fa.waitFinderTitle": "Votre annonce est en ligne",
  "fa.waitFinderText": "Nous vous préviendrons dès qu'un trouveur remplira une déclaration.",
  "fa.expiresOn": "Expire le",
  "fa.responsesTitle": "Déclarations de trouveurs",
  "fa.compareHint": "Comparez la déclaration du trouveur avec la vôtre avant de décider.",
  "fa.colYours": "Votre déclaration",
  "fa.colFinder": "Déclaration du trouveur",
  "fa.fDate": "Date",
  "fa.fPlace": "Lieu",
  "fa.fCity": "Ville",
  "fa.fCircumstances": "Circonstances",
  "fa.fColor": "Couleur",
  "fa.fCondition": "État",
  "fa.fBrand": "Marque",
  "fa.fQuantity": "Quantité",
  "fa.fMessage": "Message du trouveur",
  "fa.approve": "Approuver",
  "fa.reject": "Rejeter",
  "fa.approveConfirm": "Approuver cette déclaration ? Vos coordonnées complètes (nom, e-mail, téléphone) seront échangées avec le trouveur.",
  "fa.rejectConfirm": "Rejeter cette déclaration ? Votre annonce reste en ligne.",
  "fa.approved": "Déclaration approuvée — coordonnées échangées",
  "fa.rejected": "Déclaration rejetée",
  "fa.finderContact": "Coordonnées du trouveur",
  "fa.ownerContact": "Coordonnées du propriétaire",
  "fa.declTitle": "J'ai trouvé cet objet",
  "fa.declSub": "Décrivez l'objet que vous avez trouvé. Le propriétaire comparera votre déclaration avec la sienne.",
  "fa.foundDate": "Date de découverte",
  "fa.foundPlace": "Lieu de découverte",
  "fa.contribTitle": "Contribution volontaire",
  "fa.contribSub": "Soutenez Findloop pour aider plus de personnes à retrouver leurs objets. Vous pouvez choisir 0 €.",
  "fa.contribNone": "Aucune contribution",
  "fa.submitDecl": "Envoyer ma déclaration",
  "fa.submitDeclPay": "Envoyer et contribuer {amount}",
  "fa.sent": "Déclaration envoyée au propriétaire.",
  "fa.waitOwnerTitle": "En attente de la décision du propriétaire",
  "fa.waitOwnerText": "Le propriétaire compare votre déclaration avec la sienne. Vous serez notifié de sa décision.",
  "fa.approvedFinder": "Le propriétaire a approuvé votre déclaration",
  "fa.approvedFinderText": "Contactez-le pour organiser la restitution.",
  "fa.rejectedFinder": "Ce n'était pas l'objet recherché",
  "fa.rejectedFinderText": "Le propriétaire indique que cet objet n'est pas le sien. Merci pour votre aide !",
  "fa.contribPaid": "Contribution reçue — merci !",
  "fa.contribPending": "Contribution en attente de paiement",
  "fa.pubSuccessTitle": "Annonce publiée",
  "fa.pubSuccessMsg": "Votre annonce est en ligne. Vous serez notifié dès qu'un trouveur se manifestera.",
  "fa.contribSuccessTitle": "Merci pour votre contribution",
  "fa.contribSuccessMsg": "Votre déclaration a bien été envoyée au propriétaire.",
  "fa.waitClaimText": "Le trouveur examine votre demande. Vous serez notifié de sa décision.",
  "st.pending_payment": "Paiement en attente",
  "hc.step": "Étape",
  "hc.keysForgottenOnABench": "Trousseau de clés oublié sur un banc",
  "hc.findoPresentationVideo": "Vidéo de présentation Findloop",
  "hc.theKbisNumberAndVat": "Le numéro Kbis et le numéro de TVA sont obligatoires pour la France.",
  "hc.country": "Pays",
  "hc.phoneOptional": "Téléphone (optionnel)",
  "hc.addressStreet": "Adresse — Rue",
  "hc.city": "Ville",
  "hc.countryAddress": "Pays (adresse)",
  "hc.paymentAlreadyConfirmedByThe": "Paiement déjà confirmé par le partenaire",
  "hc.itemAlreadyConfirmed": "Objet déjà confirmé",
  "hc.youHaveAlreadyConfirmedThat": "Vous avez déjà validé qu'il s'agit bien de votre objet.",
  "hc.reviewTheItemDetails": "Revoir la fiche de l'objet",
  "hc.shippingPaid": "Expédition payée ✓",
  "hc.payTheShippingFees": "Payer les frais d'expédition",
  "hc.trackMyRecovery": "Suivre ma récupération",
  "hc.changeMethod": "Changer de mode",
  "hc.waitingForThePartnerS": "En attente de la confirmation du partenaire",
  "hc.hasConfirmedYourPaymentYou": "aura confirmé votre paiement, vous serez redirigé automatiquement",
  "hc.asSoonAs": "Dès que",
  "hc.toTheShippingFeePayment": "vers le paiement des frais d'expédition.",
  "hc.toYourRecoveryTracking": "vers le suivi de votre récupération.",
  "hc.reopenThePaymentLink": "Rouvrir le lien de paiement",
  "hc.payTheRecoveryFees": "Payer les frais de récupération",
  "hc.itemDetails": "Fiche de l'objet",
  "hc.close": "Fermer",
  "hc.category": "Catégorie",
  "hc.establishment": "Établissement",
  "hc.brand": "Marque",
  "hc.color": "Couleur",
  "hc.condition": "État",
  "hc.depositedOn": "Déposé le",
  "hc.describeTheItemBrandColor": "Décrivez l'objet : marque, couleur, signes distinctifs… (Plus vous donnez de détails, plus vos chances de retrouver votre objet sont élevées)",
  "hc.parisGareDeLyon": "Paris, Gare de Lyon…",
  "hc.payForTheShipmentOf": "Réglez l'envoi de votre objet à Findloop via un paiement sécurisé.",
  "hc.yourShippingFeesHaveBeen": "Vos frais d'expédition ont bien été réglés. Votre colis est en préparation.",
  "hc.confirmYourShippingAddressTo": "Confirmez votre adresse d'expédition pour poursuivre le paiement.",
  "hc.potentialMatchBeingVerified": "Correspondance potentielle en cours de vérification",
  "hc.recoveryOfferedByTheEstablishment": "Récupération offerte par l'établissement — aucun frais n'est perçu par findloop.",
  "hc.recoveryFeesArePaidDirectly": "Les frais de récupération sont réglés directement à l'établissement partenaire. Findloop ne perçoit aucun paiement de la part des clients.",
  "hc.awaitingPayment": "En attente de paiement",
  "hc.paymentReceived": "Paiement reçu",
  "hc.labelBeingGenerated": "Étiquette en cours de génération",
  "hc.parcelBeingPrepared": "Colis en cours de préparation",
  "hc.parcelShipped": "Colis expédié",
  "hc.parcelDelivered": "Colis livré",
  "hc.status": "Statut",
  "hc.sharePreview": "Aperçu du partage",
  "hc.verifyingTheLink": "Vérification du lien…",
  "hc.ownershipConfirmed": "Propriété confirmée",
  "hc.redirectingToTheRecoveryOf": "Redirection vers la récupération de votre objet…",
  "hc.goToMyAccount": "Accéder à mon compte",
  "hc.claimNotFound": "Réclamation introuvable",
  "hc.thisValidationLinkIsInvalid": "Ce lien de validation est invalide ou a expiré.",
  "hc.claimApproved": "Réclamation approuvée",
  "hc.claimRejected": "Réclamation rejetée",
  "hc.theClaimantHasBeenNotified": "Le réclamant a été notifié et peut désormais poursuivre la restitution.",
  "hc.theClaimantHasBeenInformed": "Le réclamant a été informé. L'objet reste disponible dans l'annonce publique.",
  "hc.identityVerification": "Vérification d'identité",
  "hc.theOwnerDescribesTheirItem": "Le propriétaire décrit son objet",
  "hc.aClaimToValidate": "Une réclamation à valider",
  "hc.aUser": "Un utilisateur",
  "hc.recognizedThePhotoYouSent": "a reconnu la photo que vous avez envoyée et décrit ces caractéristiques. Confirmez uniquement si elles correspondent à l'objet en votre possession.",
  "hc.claimsToBeTheOwner": "affirme être le propriétaire de cet objet et a répondu aux questions de vérification. Approuvez uniquement si les réponses correspondent.",
  "hc.noAnswerProvided": "Aucune réponse fournie.",
  "hc.approveTheClaim": "Approuver la réclamation",
  "hc.rejectTheClaim": "Rejeter la réclamation",
  "hc.backToHome": "Retour à l'accueil",
  "hc.isThisReallyYourItem": "Est-ce bien votre objet ?",
  "hc.freeRecoveryAcrossAfricaLaunch": "Récupération gratuite pour toute l'Afrique – Offre de lancement",
  "hc.checkTheDetailsBeforeContacting": "Vérifiez les détails avant de contacter le trouveur.",
  "hc.yesContactTheFinder": "Oui, contacter le trouveur",
  "hc.thisIsNotMyItem": "Ce n'est pas mon objet",
  "hc.paymentSuccessful": "Paiement réussi !",
  "hc.yourAccountIsActiveYou": "Votre compte est actif, vous pouvez désormais gérer vos établissements.",
  "hc.yourPaymentHasBeenRecorded": "Votre paiement a bien été enregistré.",
  "hc.yourShipmentIsBeingPrepared": "Votre expédition est en cours de préparation. Vous recevrez votre colis sous 3 à 5 jours ouvrés.",
  "hc.paymentNotCompletedYourAccount": "Paiement non finalisé, votre compte n'a pas été créé — réessayez.",
  "hc.verificationSentToThePartner": "Vérification envoyée au partenaire. Vous serez notifié de sa décision.",
  "hc.declarationNotFound": "Déclaration introuvable.",
  "hc.aNewMatchHasBeen": "Une nouvelle correspondance a été trouvée",
  "hc.weRanTheAnalysisAgain": "Nous avons relancé l'analyse et identifié un autre objet susceptible d'être le vôtre. Vérifiez-le à nouveau.",
  "hc.checkTheNewItem": "Vérifier le nouvel objet",
  "hc.thankYouForYourFeedback": "Merci pour votre retour",
  "hc.weHaveInformedTheEstablishment": "Nous avons informé l'établissement que cet objet n'est pas le vôtre et relancé l'analyse. Vous serez prévenu dès qu'une nouvelle correspondance sera trouvée.",
  "hc.backToMyAccount": "Retour à mon compte",
  "hc.checkThePhotosAndCharacteristics": "Vérifiez les photos et les caractéristiques ci-dessous avant de procéder à la récupération.",
  "hc.noMatchIsAvailableFor": "Aucune correspondance n'est disponible pour le moment. Nous vous préviendrons dès qu'un objet correspondra à votre déclaration.",
  "hc.backToPayment": "Retour au paiement",
  "hc.continueToPayment": "Continuer vers le paiement",
  "hc.thisIsMyItemContinue": "C'est bien mon objet — continuer",
  "hc.verificationPending": "Vérification en attente",
  "hc.theEstablishmentIsReviewingYour": "L'établissement examine vos réponses. Vous serez notifié dès que votre réclamation sera validée, puis vous pourrez régler les frais de récupération.",
  "hc.claimNotValidated": "Réclamation non validée",
  "hc.theEstablishmentConsideredThatThis": "L'établissement a estimé que cet objet n'est pas le vôtre.",
  "hc.whyIsThisNotYour": "Pourquoi ce n'est pas votre objet ?",
  "hc.yourFeedbackHelpsUsRestart": "Votre retour nous aide à relancer l'analyse et à améliorer nos correspondances.",
  "hc.cancel": "Annuler",
  "hc.specifyYourReason": "Précisez votre raison",
  "hc.explainWhyThisItemIs": "Expliquez pourquoi cet objet n'est pas le vôtre…",
  "hc.sending": "Envoi…",
  "hc.send": "Envoyer",
  "hc.secureFindoVerification": "Vérification sécurisée Findloop",
  "hc.takenFromYourDeclaration": "repris de votre déclaration",
  "hc.draftRestoredPickUpYour": "Brouillon restauré — reprenez votre déclaration là où vous l'aviez laissée.",
  "hc.takeAPhoto": "Prendre une photo",
  "hc.correctMyDetails": "corriger mes coordonnées",
  "hc.downloadThePdf": "Télécharger le PDF",
  "hc.itemsWhoseLegalDeadlineIs": "Objets dont l'échéance légale arrive dans 15 jours ou moins (retard inclus). Les correspondances restent visibles.",
  "hc.showOnlyItemsMatchingA": "Afficher uniquement les objets ayant une correspondance avec une annonce publique (client)",
  "hc.sortItemsWithAPublic": "Trier : objets avec correspondance publique (les plus récents) en premier",
  "hc.recentMatchesFirst": "Matches récents d'abord",
  "hc.unclaimedItemsMatchLeftWithout": "Objets non réclamés : correspondance restée sans réclamation dans les délais. Vous pouvez les remettre en dépôt.",
  "hc.unclaimedItems": "Objets non réclamés",
  "hc.activeMatchWithAPublic": "Correspondance active avec une annonce publique (client). En attente de réclamation par le propriétaire.",
  "hc.awaitingClaim": "En attente de réclamation",
  "hc.unclaimedItemNoClaimWithin": "Objet non réclamé — aucune réclamation dans les délais.",
  "hc.unclaimed": "Non réclamé",
  "hc.depositCancelledItemRemovedFrom": "Dépôt annulé — objet retiré du registre.",
  "hc.depositCancelledItemPutBack": "Dépôt annulé — objet remis en stock.",
  "hc.itemPutBackInStorage": "Objet remis en dépôt.",
  "hc.unclaimedItem": "Objet non réclamé",
  "hc.putBackInStorage": "Remettre en dépôt",
  "hc.potentialOwner": "Propriétaire potentiel",
  "hc.customerWhosePublicListingMatches": "Client dont l'annonce publique correspond à cet objet — visible par vous uniquement.",
  "hc.cancelTheDeposit": "Annuler le dépôt",
  "hc.correctThisEntry": "Corriger cette saisie ?",
  "hc.yesCancel": "Oui, annuler",
  "hc.no": "Non",
  "hc.theItemWillBeRemoved": "L'objet sera retiré du registre (aucune réclamation en cours).",
  "hc.theItemWillBeSet": "L'objet sera remis en statut « en stock » et la réclamation associée annulée.",
  "hc.itemWeight": "Poids de l'objet :",
  "hc.weightNotProvidedTheShipping": "Poids non renseigné : le tarif d'expédition sera calculé au moment de l'expédition.",
  "hc.calculatingTheShippingRate": "Calcul du tarif d'expédition…",
  "hc.reminderDelaySaved": "Délai de relance enregistré",
  "hc.recoveryPaymentLinkSavedFor": "Lien de paiement récupération enregistré pour cet établissement",
  "hc.sendcloudSenderIdSaved": "Identifiant expéditeur Sendcloud enregistré",
  "hc.recoveryFeesEnabled": "Frais de récupération activés",
  "hc.freeRecoveryFeesDisabled0": "Récupération offerte : frais désactivés (0 €)",
  "hc.defaultCarrierRemoved": "Transporteur par défaut retiré",
  "hc.emailPreferencesUpdated": "Préférences email mises à jour",
  "hc.establishmentSettings": "Paramètres de l'établissement",
  "hc.yourEstablishment": "Votre établissement",
  "hc.recoveryFees": "Frais de récupération",
  "hc.administratorOnly": "Réservé à l'administrateur",
  "hc.whenDisabledFeesDropTo": ". Désactivés, les frais passent à",
  "hc.andRecoveryIs": "et la récupération est",
  "hc.enableOrDisableRecoveryFees": "Activez ou désactivez les frais de récupération pour",
  "hc.feesEnabled": "Frais activés",
  "hc.freeRecovery0": "Récupération offerte (0 €)",
  "hc.theCustomerPaysTheFees": "Le client règle les frais à l'établissement.",
  "hc.noFeesAreChargedTo": "Aucun frais n'est demandé au client.",
  "hc.customerReminderDelay": "Délai de relance du client",
  "hc.ifThePartnerHasNot": "Si le partenaire n'a pas confirmé la réception du paiement externe après ce délai, Findloop relance automatiquement le partenaire pour validation.",
  "hc.delayHours": "Délai (heures)",
  "hc.defaultCarrier": "Transporteur par défaut",
  "hc.automaticallyPreSelected": "pré-sélectionné automatiquement",
  "hc.forEveryNewShipmentFrom": "à chaque nouvelle expédition de",
  "hc.youCanStillChangeIt": ". Vous pourrez toujours le changer au cas par cas.",
  "hc.thisCarrierWillBe": "Ce transporteur sera",
  "hc.noneChooseForEachShipment": "Aucun (choix à chaque expédition)",
  "hc.eGColisPriv": "Ex. Colis Privé",
  "hc.isNotEnabledOnYour": "n'est pas activé sur votre compte Sendcloud pour certaines destinations. Les étiquettes y seront générées avec un autre transporteur disponible.",
  "hc.none": "aucun",
  "hc.isAvailableOnSendcloudFor": "est disponible chez Sendcloud pour toutes vos routes (national + international).",
  "hc.carrierAvailabilityCannotBeChecked": "La disponibilité du transporteur ne peut pas être vérifiée tant que votre expéditeur Sendcloud n'est pas configuré.",
  "hc.emailNotificationPreferences": "Préférences de notifications email",
  "hc.chooseTheLegalRetentionAlerts": "Choisissez les alertes de durée légale reçues par email pour",
  "hc.doesNotHide": "ne masque pas",
  "hc.theBannerDisplayedInThe": "la bannière affichée dans le registre.",
  "hc.disablingAnEmail": "Désactiver un email",
  "hc.j15EarlyReminder": "Rappel anticipé J-15",
  "hc.15DaysBeforeAnItem": "15 jours avant l'échéance légale d'un objet.",
  "hc.j7EarlyReminder": "Rappel anticipé J-7",
  "hc.7DaysBeforeAnItem": "7 jours avant l'échéance légale d'un objet.",
  "hc.deadlineAlert": "Alerte à l'échéance",
  "hc.theDayTheLegalRetention": "Le jour où la durée légale de conservation est atteinte.",
  "hc.externalPaymentLinks": "Liens de paiement externes",
  "hc.onlyEachSiteManagesIts": "uniquement. Chaque site a son autonomie bancaire : ces liens n'affectent aucun autre établissement.",
  "hc.linkedTo": "Rattachés à",
  "hc.leaveTheFieldsEmptyTo": "Laissez les champs vides pour proposer la récupération gratuitement.",
  "hc.recoveryPaymentLink": "Lien de paiement récupération",
  "hc.shippingFeesAreHandledAutomatically": "Les frais d'expédition sont gérés automatiquement par Findloop (Sendcloud) — aucun lien à saisir.",
  "hc.contactFindoToGetYour": "Contactez Findloop pour obtenir votre Sender ID.",
  "hc.findoRegistersTheAddressOf": "Findloop enregistre l'adresse de votre",
  "hc.establishmentInItsSendcloudAccount": "établissement dans son compte Sendcloud et vous communique l'identifiant expéditeur",
  "hc.pasteThisSenderIdIn": "Collez ce Sender ID dans Findloop → Paramètres",
  "hc.inTheField": ", dans le champ",
  "hc.thisStepIsRequiredFor": "Cette étape est obligatoire pour que les étiquettes d'expédition soient générées",
  "hc.automaticallyWhenShipping": "automatiquement lors des expéditions.",
  "hc.sendcloudSenderIdSenderId": "Identifiant expéditeur Sendcloud (sender_id)",
  "hc.thisFieldIsRequiredFor": "Ce champ est obligatoire pour la génération automatique des étiquettes.",
  "hc.onlyTheOwnerOrAn": "Seul le propriétaire ou un administrateur peut configurer les liens de paiement de l'établissement.",
  "hc.paid": "Payée",
  "hc.failed": "Échouée",
  "hc.upcoming": "À venir",
  "hc.historyOfYourMonthlySubscriptions": "Historique de vos abonnements mensuels et de leur statut de paiement.",
  "hc.noInvoiceYet": "Aucune facture pour le moment.",
  "hc.period": "Période",
  "hc.paidOn": "Payée le",
  "hc.weight": "Poids",
  "hc.weightUnit": "Unité de poids",
  "hc.requiredUsedToCalculateThe": "Obligatoire : sert au calcul du tarif d'expédition Sendcloud. Expédition indisponible au-delà de 30 kg.",
  "hc.dimensionsCm": "Dimensions (cm)",
  "hc.optional": "optionnel",
  "hc.ifProvidedTheVolumetricWeight": "Si renseignées, le poids volumétrique est utilisé.",
  "hc.shippingNotAvailableForItems": "Expédition non disponible pour les objets de plus de 30 kg. Le client devra récupérer l'objet en main propre.",
  "hc.passedOnToTheCustomer": "— répercuté sur le lien de paiement client.",
  "hc.theShippingRateWillBe": "Le tarif d'expédition sera calculé automatiquement via Sendcloud au moment de l'expédition (poids enregistré).",
  "hc.addressSaved": "Adresse enregistrée",
  "hc.pleaseProvideAReason": "Merci d'indiquer une raison.",
  "hc.accountDeactivatedAReactivationEmail": "Compte désactivé. Un email de réactivation (valable 30 jours) vous a été envoyé.",
  "hc.recommended": "Recommandé",
  "hc.paymentLinksAreNowConfigured": "Les liens de paiement sont désormais configurés par établissement",
  "hc.eachSiteManagesItsOwn": "Chaque site a son autonomie bancaire. Rendez-vous dans",
  "hc.settings": "Paramètres",
  "hc.toConfigureTheLinksAnd": "pour configurer les liens et le délai de relance de chaque établissement.",
  "hc.openSettings": "Ouvrir les Paramètres →",
  "hc.streetNo": "N° de rue",
  "hc.optional2": "(optionnel)",
  "hc.streetName": "Nom de rue",
  "hc.mainStreet": "Rue de la Paix",
  "hc.deletingDeactivatesYourAccountLogin": "La suppression désactive votre compte : connexion bloquée et données conservées 30 jours. Vous recevrez un email avec un lien de réactivation valable 30 jours.",
  "hc.deleteMyAccount": "Supprimer mon compte",
  "hc.helpUsImproveWhyAre": "Aidez-nous à nous améliorer : pourquoi partez-vous ? Votre compte sera désactivé et réactivable pendant 30 jours.",
  "hc.chooseAReason": "Choisir une raison",
  "hc.missingFeatures": "Fonctionnalités manquantes",
  "hc.iDonTUseIt": "Je ne l'utilise pas assez",
  "hc.anyCommentsOptional": "Un commentaire ? (optionnel)",
  "hc.tellUsMore": "Dites-nous en plus…",
  "hc.confirmDeletion": "Confirmer la suppression",
  "hc.delivered": "Livré",
  "hc.shipments": "Expéditions",
  "hc.searchByCustomerItemOr": "Rechercher par client, objet ou n° de suivi…",
  "hc.dateNewest": "Date (plus récent)",
  "hc.dateOldest": "Date (plus ancien)",
  "hc.noShipmentsYet": "Aucune expédition pour l'instant.",
  "hc.item": "Objet",
  "hc.date": "Date",
  "hc.noShipmentMatchesYourSearch": "Aucune expédition ne correspond à votre recherche.",
  "hc.openTheDeclarationToManage": "Ouvrir la fiche de déclaration pour gérer l'expédition",
  "hc.claimApproved2": "Réclamation approuvée.",
  "hc.claimRejected2": "Réclamation rejetée.",
  "hc.aUserClaimsToBe": "Un utilisateur affirme être le propriétaire. Vérifiez ses réponses avant d'autoriser la restitution.",
  "hc.yourVerificationQuestionsDeposit": "Vos questions de vérification (dépôt)",
  "hc.compareThemWithTheOwner": "Comparez-les aux réponses du propriétaire — jamais visible publiquement.",
  "hc.claimCodeVerified": "Code de réclamation vérifié",
  "hc.newCodeGeneratedAndSent": "Nouveau code généré et envoyé au client par email et SMS",
  "hc.itemMarkedAsReturned": "Objet marqué comme restitué ✓",
  "hc.declarationClosed": "Déclaration clôturée ✓",
  "hc.noArchivedDeclarations": "Aucune déclaration archivée",
  "hc.noDeclarations": "Aucune déclaration",
  "hc.processedCasesWillAppearHere": "Les dossiers traités apparaîtront ici.",
  "hc.shareYourQrCodeTo": "Partagez votre QR code pour recevoir des déclarations.",
  "hc.cancelled": "Annulée",
  "hc.collapse": "Réduire",
  "hc.cancelledByTheCustomer": "Annulée par le client",
  "hc.confirmed": "Confirmé ✓",
  "hc.returnSecurity": "Sécurité restitution",
  "hc.customerClaimCodeToCheck": "Code de réclamation du client — à vérifier au moment du retrait :",
  "hc.codeAlreadyVerified": "Code déjà vérifié",
  "hc.claimCodeExpired": "Code de réclamation expiré",
  "hc.regenerateTheCode": "Régénérer le code",
  "hc.enterTheCustomerSCode": "Saisir le code du client",
  "hc.verify": "Vérifier",
  "hc.toCheckBeforeMarkingThe": "À vérifier avant de marquer l'objet comme restitué.",
  "hc.comparePhotos": "Comparer les photos",
  "hc.firstVerifyTheClaimCode": "Vérifiez d'abord le code de réclamation ci-dessus",
  "hc.markAsReturned": "Marquer comme restitué",
  "hc.createTheShipment": "Créer l'expédition",
  "hc.closeTheDeclaration": "Clôturer la déclaration",
  "hc.trackTheShipmentAndDownload": "Suivez l'expédition et téléchargez l'étiquette (générée automatiquement) sans quitter l'onglet Déclarations.",
  "hc.noShipmentsYet2": "Aucune expédition pour l'instant",
  "hc.theShipmentIsCreatedAutomatically": "L'expédition est créée automatiquement une fois que le client a confirmé son adresse et réglé les frais de récupération. L'étiquette sera ensuite générée automatiquement après le paiement de l'expédition, et téléchargeable ici.",
  "hc.closeTheDeclaration2": "Clôturer la déclaration ?",
  "hc.returned": "restitué",
  "hc.andTheDeclarationWillBe": "et la déclaration sera clôturée (déplacée vers l'historique). Cette action est définitive.",
  "hc.close2": "Clôturer",
  "hc.limitReachedUpgradeToA": "Limite atteinte — passez à un plan supérieur",
  "hc.previewOfThePrintReady": "Aperçu de l'affiche A4 prête à imprimer pour cet établissement.",
  "hc.posterPreview": "Aperçu de l'affiche",
  "hc.accountActivatedPleaseLogIn": "Compte activé, connectez-vous.",
  "hc.passwordResetPleaseLogIn": "Mot de passe réinitialisé, connectez-vous.",
  "hc.chooseYourPasswordToAccess": "Choisissez votre mot de passe pour accéder à la console d'administration.",
  "hc.accountReactivation": "Réactivation du compte",
  "hc.reactivating": "Réactivation en cours…",
  "hc.yourAccountHasBeenReactivated": "Votre compte a été réactivé.",
  "hc.logInToGetBack": "Connectez-vous pour retrouver votre espace et gérer votre abonnement.",
  "hc.invalidOrExpiredReactivationLink": "Lien de réactivation invalide ou expiré",
  "hc.theLinkMayHaveExpired": "Le lien est peut-être périmé (valable 30 jours). Contactez le support Findloop si besoin.",
  "hc.adminFullView": "Admin (vue complète)",
  "hc.passwordsDoNotMatch": "Les mots de passe ne correspondent pas.",
  "hc.accountActivation": "Activation du compte",
  "hc.goToLogin": "Aller à la connexion",
  "hc.role": "Rôle :",
  "hc.establishment2": "Établissement :",
  "hc.password": "Mot de passe",
  "hc.atLeast6Characters": "Au moins 6 caractères",
  "hc.confirmPassword": "Confirmer le mot de passe",
  "hc.repeatThePassword": "Répétez le mot de passe",
  "hc.accountCreated": "Compte créé !",
  "hc.redirectingToPayment": "Redirection vers le paiement…",
  "hc.hotelBelmont": "Hôtel Belmont",
  "hc.confirmYourSubscription": "Confirmez votre abonnement",
  "hc.youWillBeRedirectedTo": "Vous allez être redirigé vers le paiement sécurisé Stripe.",
  "hc.selectedPlan": "Plan sélectionné",
  "hc.edit": "Modifier",
  "hc.confirmAndPay": "Confirmer et payer",
  "hc.youBusinessCom": "vous@etablissement.com",
  "hc.reset": "Réinitialiser",
  "hc.previousPhoto": "Photo précédente",
  "hc.clickToZoom": "Cliquez pour zoomer",
  "hc.caseClosedThankYou": "Dossier clôturé. Merci !",
  "hc.waitingForPartnerConfirmation": "En attente de confirmation du partenaire",
  "hc.cancelMyDeclaration": "Annuler ma déclaration",
  "hc.giveTheReasonForCancelling": "Indiquez le motif d'annulation. Le partenaire en sera informé.",
  "hc.verificationSentToTheFinder": "Vérification envoyée au trouveur. Vous serez notifié de sa décision.",
  "hc.theFinderIsReviewingYour": "Le trouveur examine votre réclamation. Vous serez notifié dès qu'elle sera validée.",
  "hc.theFinderConsideredThatThis": "Le trouveur a estimé que cet objet n'est pas le vôtre.",
  "hc.claimValidated": "Réclamation validée",
  "hc.unlockTheFinderSContact": "Débloquez les coordonnées du trouveur pour organiser la remise.",
  "hc.confirmThatThisIsYour": "Confirmez qu'il s'agit de votre objet. Une vérification d'identité sera demandée au trouveur avant toute mise en relation.",
  "hc.thisIsMyItem": "C'est mon objet",
  "hc.enlargePhoto": "Agrandir la photo",
  "hc.reasonSavedYouCanStill": "Motif enregistré. Vous pouvez toujours réclamer votre objet.",
  "hc.cancelThisMatch": "Annuler cette correspondance",
  "hc.tellUsWhyYourListing": "Indiquez pourquoi. Votre annonce reste active et vous pourrez toujours réclamer votre objet.",
  "hc.reportDismissedYourListingRemains": "Signalement écarté. Votre annonce reste publique.",
  "hc.listingHiddenByModeration": "Annonce masquée par la modération.",
  "hc.yourItemHasBeenShipped": "Votre objet a été expédié par le partenaire — clôturez une fois l'expédition confirmée.",
  "hc.yourItemHasBeenHanded": "Votre objet a été remis en main propre par le partenaire — clôturez une fois la remise confirmée.",
  "hc.finderAcceptedCloseTheCase": "Trouveur accepté — clôturez une fois l'objet remis en main propre.",
  "hc.makeSureThisIsThe": "Vérifiez qu'il s'agit bien de l'objet que vous avez perdu avant de débloquer les coordonnées du trouveur.",
  "hc.specifyWhetherYouRecoveredYour": "Précisez si vous avez récupéré votre objet ou si vous souhaitez simplement retirer cette annonce.",
  "hc.thisMatchIsNoLonger": "Cette correspondance n'est plus disponible ou a déjà été traitée.",
  "hc.weHaveInformedThePartner": "Nous avons informé le partenaire que cet objet n'est pas le vôtre. Votre annonce reste active pour de futurs rapprochements.",
  "hc.itemFoundAtAPartner": "Objet trouvé chez un partenaire",
  "hc.isThisYourItem": "Est-ce votre objet ?",
  "hc.checkTheDetailsBelowBefore": "Vérifiez les détails ci-dessous avant de lancer votre déclaration de restitution.",
  "hc.claimValidatedByThePartner": "Réclamation validée par le partenaire",
  "hc.youCanNowStartThe": "Vous pouvez maintenant lancer la restitution.",
  "hc.continueTheReturn": "Continuer la restitution",
  "hc.thePartnerIsReviewingYour": "Le partenaire examine vos réponses. Vous serez notifié dès que votre réclamation sera validée.",
  "hc.thePartnerConsideredThatThis": "Le partenaire a estimé que cet objet n'est pas le vôtre. L'objet reste disponible.",
  "hc.thisIsMyItemStart": "C'est mon objet — lancer la restitution",
  "hc.yourFeedbackHelpsUsImprove": "Votre retour nous aide à améliorer nos correspondances.",
  "hc.hidePassword": "Masquer le mot de passe",
  "hc.showPassword": "Afficher le mot de passe",
  "hc.carrierSelection": "Choix du transporteur",
  "hc.shippingFeesHaveAlreadyBeen": "Les frais d'expédition sont déjà réglés : le transporteur ne peut plus être modifié.",
  "hc.simulatedRatesInPreProduction": "(tarifs simulés en préproduction)",
  "hc.rateChargedToTheCustomer": "Tarif facturé au client :",
  "hc.thisRateWillBeCharged": "Ce tarif sera facturé au client. Un tarif élevé peut décourager la récupération.",
  "hc.confirmTheCarrier": "Confirmer le transporteur",
  "hc.beforeAfterComparisonSlider": "Curseur de comparaison avant/après",
  "hc.theLabelIsGeneratedAutomatically": "L'étiquette est générée automatiquement dès que le client a réglé les frais d'expédition. Elle sera téléchargeable ici.",
  "hc.adjustThePhoto": "Ajuster la photo",
  "hc.dragToReposition": "Glissez pour repositionner",
  "hc.fullPhoto": "Photo entière",
  "hc.confirmCrop": "Valider le recadrage",
  "hc.stopScrolling": "Arrêter le défilement",
  "hc.scrollThroughLanguages": "Défiler les langues",
  "hc.declarationNotFound2": "Déclaration introuvable",
  "hc.pleaseCompleteYourShippingAddress": "Merci de compléter votre adresse d'expédition.",
  "hc.pleaseProvideAPhoneNumber": "Merci d'indiquer un numéro de téléphone : il est requis par le transporteur pour l'expédition.",
  "hc.invalidNumberEnterAnInternational": "Numéro invalide. Saisissez un numéro international, ex : +33 6 12 34 56 78.",
  "hc.yourShippingFeesHaveAlready": "Vos frais d'expédition sont déjà réglés. Expédition payée ✓",
  "hc.unableToOpenTheShipping": "Impossible d'ouvrir le paiement des frais d'expédition. Merci de réessayer.",
  "hc.shippingAddress": "Adresse d'expédition",
  "hc.checkOrEditYourDetails": "Vérifiez ou modifiez vos coordonnées avant le paiement sécurisé.",
  "hc.fullName": "Nom et prénom",
  "hc.phoneNumber": "Numéro de téléphone",
  "hc.iFoundItElsewhere": "Je l'ai retrouvé ailleurs",
  "hc.theFeesAreTooHigh": "Les frais sont trop élevés",
  "hc.iNoLongerNeedMy": "Je n'ai plus besoin de mon objet",
  "hc.specifyYourReason2": "Précisez votre motif…",
  "hc.back": "Retour",
  "hc.signInTheBoxAbove": "Signez dans le cadre ci-dessus",
  "hc.signatureSaved": "Signature enregistrée",
  "hc.findoCityRanking": "Findloop — Classement des villes",
  "hc.toReachOurFirstMilestone": "pour franchir notre premier cap des 100 restitutions.",
  "hc.only": "Plus que",
  "hc.high": "Élevé",
  "hc.platformReturnTarget": "Objectif de restitution de la plateforme",
  "hc.targetReachedThankYouTo": "Objectif atteint — merci à toute la communauté Findloop !",
  "hc.overallRateTrendLast6": "Évolution du taux global (6 derniers mois)",
  "hc.topCitiesForReturns": "Villes championnes de la restitution",
  "hc.shareTheRanking": "Partager le classement",
  "hc.impersonationSessionExpired": "Session d'impersonation expirée.",
  "hc.impersonationEnded": "Impersonation terminée.",
  "hc.signedInWithGoogle": "Connecté avec Google",
  "hc.viewInRegistry": "Voir dans le registre",
  "hc.viewItem": "Voir l'objet",
  "hc.sessionExpired": "Connexion expirée",
  "hc.stillThere": "Toujours là ?",
  "hc.staySignedIn": "Rester connecté",
  "hc.termsAndPolicies": "Conditions et politiques",
  "hc.termsAndConditions": "Conditions générales",
  "hc.privacyPolicy": "Politique de confidentialité",
  "hc.legalNotice": "Mentions légales",
  "hc.contactUs": "Nous contacter",
  "hc.addOnGoogle": "Ajouter sur Google",
  "hc.manageCookies": "Gérer les cookies",
  "hc.previous": "Précédent",
  "hc.next": "Suivant",
  "hc.newCodeGeneratedAndSent2": "Nouveau code généré et envoyé au propriétaire",
  "hc.itemPhotoSaved": "Photo de l'objet enregistrée",
  "hc.questionsToAskTheOwner": "Questions à poser au propriétaire",
  "hc.askThemAtTheCounter": "Posez-les en caisse pour confirmer l'identité — jamais visible publiquement.",
  "hc.regenerateAndResendToThe": "Régénérer et renvoyer au propriétaire",
  "hc.ownerSClaimCode": "Code de réclamation du propriétaire",
  "hc.scanTheOwnerSQr": "Scanner le QR du propriétaire",
  "hc.theOwnerReceivedItBy": "Le propriétaire l'a reçu par email (ou SMS). À saisir ou scanner avant la remise.",
  "hc.originalListingPhotoUsed": "Photo d'origine de l'annonce utilisée",
  "hc.preFilledAutomaticallyYouCan": "Pré-remplie automatiquement — vous pouvez la remplacer par une photo du colis.",
  "hc.itemPreview": "Aperçu de l'objet",
  "hc.takeChangeThePhoto": "Prendre / changer la photo",
  "hc.itemPhotoRequiredBeforeShipping": "Photo de l'objet (obligatoire avant expédition)",
  "hc.addAPhoto": "Ajouter une photo",
  "hc.visibleToTheOwnerAutomatically": "Visible par le propriétaire · supprimée automatiquement après 60 jours.",
  "hc.proofOfReturnPdf": "Preuve de restitution (PDF)",
  "hc.scanTheClaimCode": "Scanner le code de réclamation",
  "hc.cameraUnavailableEnterTheCode": "Caméra indisponible. Saisissez le code manuellement.",
  "hc.askTheOwnerToDisplay": "Demandez au propriétaire d'afficher le QR de son code (page de suivi).",
  "hc.registerAFoundItem": "Enregistrer un objet trouvé",
  "hc.openDepositInTheMenu": "Ouvrez « Dépôt » dans le menu, décrivez l'objet et prenez une photo. Il est immédiatement rangé et prêt à être restitué.",
  "hc.storeFindWithQr": "Ranger & retrouver avec le QR",
  "hc.eachItemGetsAQr": "Chaque objet reçoit une étiquette QR. Scannez-la depuis « Rangement & QR » pour localiser un objet en un instant.",
  "hc.returnToTheOwner": "Restituer au propriétaire",
  "hc.whenACustomerComesTo": "Quand un client vient récupérer son bien, ouvrez sa déclaration et validez la restitution. C'est terminé !",
  "hc.manageYourTeam": "Gérer votre équipe",
  "hc.fromTeamInviteYourColleagues": "Depuis « Équipe », invitez vos collaborateurs par email et assignez-leur un établissement. Chaque membre ne voit que son périmètre.",
  "hc.setUpYourEstablishments": "Configurer vos établissements",
  "hc.addAndConfigureYourEstablishments": "Ajoutez et paramétrez vos établissements dans « Établissements » : coordonnées, catégorie et rangement physique des objets.",
  "hc.trackYourStatistics": "Suivre vos statistiques",
  "hc.checkStatisticsToTrackDeposited": "Consultez « Statistiques » pour suivre objets déposés, taux de restitution et performance de chaque établissement.",
  "hc.manageMyTeam": "Gérer mon équipe",
  "hc.depositAnItem": "Déposer un objet",
  "hc.yourFirstStepsAdmin": "Vos premiers pas (admin)",
  "hc.yourFirstSteps": "Vos premiers pas",
  "hc.privacy": "Confidentialité",
  "hc.cropThePhoto": "Recadrer la photo",
  "hc.moveThePhotoToFit": "Déplacez la photo pour la cadrer dans le cercle.",
  "hc.save": "Enregistrer",
  "hc.8CharactersMinimum": "8 caractères minimum.",
  "hc.passwordUpdated": "Mot de passe mis à jour.",
  "hc.chooseANewPassword": "Choisissez un nouveau mot de passe",
  "hc.pleaseSetYourOwnPassword": "veuillez définir votre propre mot de passe avant de continuer.",
  "hc.newPassword": "Nouveau mot de passe",
  "hc.confirmThePassword": "Confirmez le mot de passe",
  "hc.saveAndContinue": "Enregistrer et continuer",
  "hc.billingInformationSaved": "Informations de facturation enregistrées ✓",
  "hc.unableToRetrieveTheInvoice": "Impossible de récupérer la facture.",
  "hc.billingInformation": "Informations de facturation",
  "hc.siretAndVatNumberRequired": "SIRET et numéro de TVA obligatoires (France).",
  "hc.intraEuVatNumberOptional": "Numéro de TVA intracommunautaire optionnel, pas de SIRET requis (hors France).",
  "hc.countryIsoCodeEG": "Pays (code ISO, ex. FR)",
  "hc.address": "Adresse",
  "hc.optional3": "optionnel",
  "hc.noInvoiceYetYourInvoices": "Aucune facture pour le moment. Vos factures apparaîtront ici automatiquement après chaque paiement.",
  "hc.assistanceSessionRevoked": "Session d'assistance révoquée.",
  "hc.aFindoAssistanceSessionIs": "Une session d'assistance Findloop est actuellement active sur votre compte.",
  "hc.revokeAccess": "Révoquer l'accès",
  "hc.chooseACountry": "Choisir un pays",
  "hc.searchForACountry": "Rechercher un pays…",
  "hc.noCountryFound": "Aucun pays trouvé",
  "hc.other": "Autre",
  "hc.cancellationReason": "Motif d'annulation",
  "hc.tellUsWhyYouCancel": "Indiquez pourquoi vous annulez. Cela aide le partenaire à traiter votre demande.",
  "hc.welcomeToFindo": "Bienvenue dans Findloop",
  "hc.skip": "Passer",
  "hc.company": "Entreprise",
  "hc.aboutFindo": "À propos de Findloop",
  "hc.careers": "Carrières",
  "hc.pressKit": "Kit presse",
  "hc.ourProducts": "Nos produits",
  "hc.findoForEstablishments": "Findloop pour établissements",
  "hc.partnerDirectory": "Annuaire partenaires",
  "hc.declarationTracking": "Suivi de déclaration",
  "hc.shipping": "Expédition",
  "hc.assistance": "Assistance",
  "hc.helpCenter": "Centre d'aide",
  "hc.reportAProblem": "Signaler un problème",
  "hc.lostFoundPlatform": "Plateforme d'objets perdus & retrouvés.",
  "hc.pending": "En attente",
  "hc.inTransit": "En cours",
  "hc.staff": "Personnel",
  "ac.emailCrossReject": "Rejets de correspondance publique",
  "ac.emailCrossRejectDesc": "Recevoir un email quand un client indique qu'une correspondance publique proposée n'est pas son objet.",
  "ac.emailLoginNotif": "Notification de connexion",
  "ac.emailLoginNotifDesc": "Recevoir un email à chaque connexion à votre compte.",
  "an.qfAll": "Toutes",
  "an.qfBoosted": "Boostées",
  "an.qfPhoto": "Avec photo",
  "an.qfRecent": "Cette semaine",
  "an.qfResolved": "Résolues",
  "dec.loadError": "Impossible de charger le partenaire pour le moment. Vérifiez votre connexion et réessayez.",
  "dec.retry": "Réessayer",
  "ft.cancelConfirm": "Annuler votre signalement ? Le propriétaire de l'objet en sera informé.",
  "ft.cancelDone": "Signalement annulé.",
  "ft.cancelReport": "Annuler mon signalement",
  "map.objectsOnMapPlural": "objets sur la carte",
  "map.objectsOnMapSingular": "objet sur la carte",
  "mc2.cancelDecl": "Annuler ma déclaration",
  "mc2.cancelDeclDone": "Déclaration annulée.",
  "shp.labelAuto": "L'étiquette est générée automatiquement dès que le client a réglé les frais d'expédition. Elle sera téléchargeable ici.",
  "stt.dispoPdfBtn": "Exporter PDF",
  "stt.dispoPdfError": "Export PDF impossible.",
  "stt.dispoPdfExporting": "Export…",
  "hc.africa": "Afrique",
  "hc.payment": "Paiement",
  "hc.locateMe": "Me localiser",
  "hc.linkUnavailable": "Lien indisponible",
  "hc.myAccount": "Mon compte",
  "hc.loading": "Chargement…",
  "hc.annualTarget": "Objectif annuel",
  "hc.reached": "atteint",
  "hc.resumeRegistration": "Reprendre l'inscription",
  "hc.clear": "Effacer",
  "hc.gallery": "Galerie",
  "hc.invalidSendcloudId": "Identifiant Sendcloud invalide",
  "hc.free": "offerte",
  "hc.toTheCustomer": "au client.",
  "hc.carrier": "Transporteur",
  "hc.other2": "Autre…",
  "hc.carrierOther": "Transporteur (autre)",
  "hc.field": ") correspondant.",
  "hc.save2": "enregistrez",
  "hc.myMonthlyInvoices": "Mes factures mensuelles",
  "hc.amount": "Montant",
  "hc.pdfInvoice": "Facture PDF",
  "hc.annual20": "Annuel -20%",
  "hc.monthly": "Mensuel",
  "hc.cover": "couverture",
  "hc.mainReason": "Raison principale",
  "hc.tooExpensiveBudget": "Trop cher / budget",
  "hc.all": "Tous",
  "hc.tracking": "Suivi",
  "hc.aiVisualComparison": "Comparaison visuelle IA",
  "hc.analyzing": "Analyse…",
  "hc.printThePoster": "Imprimer l'affiche",
  "hc.activateMyAdminAccount": "Activer mon compte admin",
  "hc.activateMyAccount": "Activer mon compte",
  "hc.logIn": "Se connecter",
  "hc.invalidInvitationLink": "Lien d'invitation invalide.",
  "hc.invalidInvitationLink2": "Lien d'invitation invalide",
  "hc.copy": "Copier",
  "hc.annualBilling20": "Facturation annuelle (−20%)",
  "hc.monthlyBilling": "Facturation mensuelle",
  "hc.welcome": "Bienvenue !",
  "hc.nextPhoto": "Photo suivante",
  "hc.resume": "Reprendre",
  "hc.matchNotFound": "Correspondance introuvable",
  "hc.partner": "Partenaire",
  "hc.switchToLightMode": "Passer en mode clair",
  "hc.switchToDarkMode": "Passer en mode sombre",
  "hc.selectedCarrier": "Transporteur retenu :",
  "hc.exit": "Quitter",
  "hc.confirmCancellation": "Confirmer l'annulation",
  "hc.lowRate": "Taux faible",
  "hc.medium": "Moyen",
  "hc.partner2": "partenaire",
  "hc.saving": "Enregistrement…",
  "hc.companyName": "Raison sociale",
  "hc.14Digits": "14 chiffres",
  "hc.myInvoices": "Mes factures",
  "hc.bronze": "Bronze",
  "hc.silver": "Argent",
  "hc.gold": "Or",
  "hc.previewMode": "Mode prévisualisation :",
  "hc.thisEstablishment": "cet établissement",
  "hc.linkCopiedShareOn": "Lien copié — partagez-le sur {label}",
  "hc.findoReviewShare": "Bilan Findloop {year} : {n} objets restitués, {rate}% de taux de restitution 🎉",
  "hc.retro": "Rétro",
  "hc.lostIn": "perdu à",
  "hc.activeMatchCancelReason": "Correspondance active. Motif d'annulation du client : « {reason} ». L'objet reste en attente de réclamation.",
  "hc.unclaimedCustomerReason": "Objet non réclamé. Motif du client : « {reason} ».",
  "hc.archiveCancelledConfirm": "Archiver {n} annonce(s) « Annulé par le client » ? Elles seront retirées du registre.",
  "hc.nArchived": "{n} annonce(s) archivée(s).",
  "hc.inviteSubtitle": "{org} vous invite à rejoindre son équipe findloop. Choisissez votre mot de passe pour activer votre compte.",
  "hc.anOrganization": "Une organisation",
  "hc.codeCopied": "Code copié",
  "hc.carrierConfirmedCharged": "Transporteur confirmé — {price} € facturés au client",
  "hc.itemsReturned": "objet(s) restitué(s)",
  "hc.targetReached": "Objectif atteint",
  "hc.target": "Objectif",
  "hc.pointsToGoal": "Encore {n} points pour atteindre notre objectif commun.",
  "hc.idleLogoutIn": "Vous serez déconnecté dans {n} s pour inactivité.",
  "hc.d15": "J-15",
  "hc.publicMatch": "Match public",
  "hc.primary": "principal",
  "hc.dangerZone": "Zone danger",
  "hc.deleting": "Suppression…",
  "hc.customer": "Client",
  "hc.inclVat": "TTC",
  "hc.impersonationMode": "Mode impersonation",
  "hc.b2cCustomer": "client B2C",
  "hc.exId": "ex : 3f2a…",
  "hc.exCode": "ex : ABCD2345",
  "hc.shareLostText": "J'ai perdu un objet — aidez-moi à le retrouver sur Findloop",
  "hc.shareFoundText": "J'ai trouvé un objet — aidez-moi à retrouver son propriétaire sur Findloop",
  "hc.smsSentIfAccount": "Si un compte existe avec ce numéro, un SMS vous a été envoyé.",
  "hc.paidViaPartner": "Payé (via partenaire)",
  "hc.youAreHere": "Vous êtes ici",
  "hc.invalidOrExpiredLink": "Lien invalide ou expiré.",
  "hc.characteristic": "Caractéristique",
  "hc.rateOfTarget": "{rate}% réalisés sur un objectif de {target}%",
  "hc.itemFoundAt": "Objet trouvé chez",
  "hc.matchNoClaimInTime": "La correspondance est restée sans réclamation dans les délais.",
  "hc.customerReasonFmt": "Motif du client : « {reason} ».",
  "hc.shipRateForWeight": "Tarif d'expédition (Sendcloud + marge {m}%) pour {w} :",
  "hc.shipRateAutoWeight": "Le tarif d'expédition est calculé automatiquement via Sendcloud (poids {w}) au moment de l'expédition.",
  "hc.settingsSubtitle": "Paiements externes et relances, configurés par établissement.",
  "hc.howConfigureSenderId": "Comment configurer mon Sender ID numérique ?",
  "hc.estShipRate": "Tarif d'expédition estimé (Sendcloud + marge {m}%) :",
  "hc.shipmentsSubtitle": "Vue consolidée de toutes les expéditions de l'établissement, tous dossiers confondus. Cliquez une ligne pour gérer l'expédition dans sa fiche de déclaration.",
  "hc.claimsToValidate": "Réclamations à valider",
  "hc.claimant": "Réclamant",
  "hc.theItem": "L'objet",
  "hc.of": "de",
  "hc.willBeMarkedAs": "sera marqué comme",
  "hc.planLimitFmt": "Votre plan « {plan} » est limité à {max} établissement. Pour gérer {n} sites, nous vous recommandons le plan",
  "hc.planAt": "à",
  "hc.switchTo": "Passer à",
  "hc.invalidInviteLink": "Lien d'invitation invalide ou expiré.",
  "hc.verifyingInvite": "Vérification du lien d'invitation…",
  "hc.activating": "Activation…",
  "hc.signupFailed": "Inscription échouée",
  "hc.cannotOpenPayment": "Impossible d'ouvrir le paiement. Réessayez.",
  "hc.redirecting": "Redirection…",
  "hc.loginFailed": "Connexion échouée",
  "hc.kbisNumber": "Numéro Kbis",
  "hc.vatNumber": "Numéro de TVA",
  "hc.cancelSavedFmt": "Annulation enregistrée : « {reason} ». Vous pouvez toujours réclamer.",
  "hc.viewItemRecover": "Voir l'objet & récupérer",
  "hc.defaultCarrierPreselected": "Transporteur par défaut présélectionné — modifiable pour cet envoi. Tarif réel (Sendcloud + marge {m}%).",
  "hc.chargedToCustomer": "facturés au client.",
  "hc.milestoneFmt": "Cap des {m} objets restitués franchi ! En route vers {next}.",
  "hc.itemsReturnedThisYear": "objets restitués cette année",
  "hc.daysToYearEnd": "J-{n} avant la fin de l'année",
  "hc.seeRetro": "Voir la rétro",
  "hc.googleLoginFailed": "Connexion Google échouée",
  "hc.protectedByRecaptcha": "Protégé par reCAPTCHA",
  "hc.updateFailed": "Échec de la mise à jour.",
  "hc.pwdResetByTeam": "Votre mot de passe a été réinitialisé par notre équipe. Pour votre sécurité,",
  "hc.usedForInvoices": "Utilisées pour émettre vos factures findloop.",
  "hc.download": "Télécharger",
  "hc.wrongColor": "Mauvaise couleur",
  "hc.wrongModel": "Pas le bon modèle",
  "hc.notMine": "Ce n'est pas le mien",
  "hc.saveBtn": "Enregistrer",
  "hc.saveLink": "Enregistrer le lien",
  "hc.view": "Voir",
  "pcat.airport": "Aéroport",
  "pcat.travel_agency": "Agence de voyage",
  "pcat.bank": "Banque",
  "pcat.bar_cafe": "Bar / Café",
  "pcat.library": "Bibliothèque",
  "pcat.mall": "Centre commercial",
  "pcat.sports_center": "Centre sportif",
  "pcat.cinema": "Cinéma",
  "pcat.airline": "Compagnie aérienne",
  "pcat.school_university": "École / Université",
  "pcat.private_company": "Entreprise privée",
  "pcat.coworking": "Espace de coworking",
  "pcat.train_bus_station": "Gare ferroviaire / routière",
  "pcat.hospital_clinic": "Hôpital / Clinique",
  "pcat.museum": "Musée",
  "pcat.tourism_office": "Office de tourisme",
  "pcat.amusement_park": "Parc d'attractions",
  "pcat.pharmacy": "Pharmacie",
  "pcat.concert_theater": "Salle de concert / Théâtre",
  "pcat.gym_fitness": "Salle de sport / Fitness",
  "pcat.beauty_salon": "Salon de coiffure / Beauté",
  "pcat.stadium_arena": "Stade / Arena",
  "pcat.supermarket": "Supermarché",
  "pcat.taxi_vtc": "Taxi / VTC",
  "pcat.public_transport": "Transport en commun",
  "hc.and": "et",
  "hc.terms": "Conditions",
  "hc.feedReal": "Un objet ({cat}) a été restitué à {city}.",
  "hc.feedDemo": "{obj} a été restitué à {city} {when}.",
  "hc.demoObj0": "un portefeuille",
  "hc.demoObj1": "un sac de sport",
  "hc.demoObj2": "un téléphone",
  "hc.demoObj3": "une paire de lunettes",
  "hc.demoObj4": "un trousseau de clés",
  "hc.demoObj5": "une écharpe",
  "hc.demoObj6": "un ordinateur portable",
  "hc.demoObj7": "une gourde",
  "hc.demoWhen0": "il y a 2 heures",
  "hc.demoWhen1": "il y a 5 heures",
  "hc.demoWhen2": "hier",
  "hc.demoWhen3": "il y a 3 heures",
  "hc.demoWhen4": "ce matin",
  "hc.demoWhen5": "il y a 1 jour",
  "hc.shareReview": "Partager le bilan",
  "an.found": "Trouvé",
  "an.lost": "Perdu",
  "hc.citiesAboveTarget": "{n} villes au-dessus de leur objectif",
  "hc.cityAboveTarget": "{n} ville au-dessus de son objectif",
  "hc.monthlyPrice": "Prix mensuel",
  "hc.perMonth": "/ mois",
  "hc.perYear": "/ an",
  "hc.annualTotal": "Total annuel",
  "hc.billedOnceYear": "Prélevé en une fois pour 12 mois, renouvelable chaque année.",
  "hc.billedEachMonth": "Prélevé automatiquement chaque mois.",
  "nav.individual": "Particulier",
  "nav.business": "Entreprise",
  "hc.firstName": "Prénom",
  "hc.lastName": "Nom de famille",
  "hc.quantity": "Nombre d'objets",
  "hc.circumstancesLost": "Circonstances de la perte",
  "hc.circumstancesFound": "Circonstances de la découverte",
  "hc.circumstancesLostPh": "Ex. oublié sur un banc en attendant le bus",
  "hc.circumstancesFoundPh": "Ex. trouvé par terre près de l'entrée du métro",
  "hc.conditionPh": "Ex. bon état, rayé…"
 },
 "en": {
  "dr.title": "You have an unfinished declaration",
  "dr.expiresIn": "Draft kept for {h} more hours",
  "dr.continue": "Continue my declaration",
  "dr.delete": "Delete permanently",
  "dr.deleteConfirm": "Permanently delete this draft? This cannot be undone.",
  "dr.deleted": "Draft deleted",
  "fa.goBack": "Go back",
  "fa.categoryRequired": "Choose a category for the found item.",
  "fa.confirmTitle": "Confirm your decision",
  "fa.cancel": "Cancel",
  "fa.africaFree": "Free listing in Africa — Findloop launch offer, enjoy it!",
  "fa.planSubFree": "Choose the duration: your listing goes live immediately, no payment needed.",
  "fa.free": "Free",
  "fa.renewDiscountHint": "50% off applied because you renew before expiry.",
  "fa.africaPublished": "Listing published for free — Africa launch offer!",
  "fa.prefillPrevious": "Reuse the details of my previous listing in this category",
  "fa.waitFinderDecision": "Waiting for the finder's decision",
  "fa.claimApprovedShort": "The finder approved your claim",
  "fa.claimUnlockedShort": "Contact details unlocked — see tracking",
  "fa.claimRejectedShort": "Claim declined by the finder",
  "fa.claimRejectedText": "The finder believes this item isn't yours.",
  "fa.claimUnlockText": "Unlock the finder's contact details to arrange the return.",
  "fa.unlockFree": "Unlock for free — launch offer",
  "fa.unlockBtn": "Unlock contact details",
  "fa.twoPhotosError": "Add 2 photos of your item.",
  "fa.claimTitle": "This is my item",
  "fa.claimSub": "Describe your item and add 2 photos. The finder will compare them with their listing.",
  "fa.checkInfo": "Check your details before sending: they will be compared with the finder's.",
  "fa.lostDate": "Date lost",
  "fa.lostPlace": "Place lost",
  "fa.twoPhotos": "2 photos of your item",
  "ph.secured": "Photo secured",
  "ph.securing": "Securing the photo…",
  "fa.ownerSafety3": "If the finder's photo carries the Findloop watermark, do not accept the meeting. The photo must be an original image taken by the finder, without a watermark.",
  "pub.changePhoto": "Change photo",
  "fa.phoneMissing": "Not provided",
  "fa.ownerSafety1": "Prefer a hand-over in a public place or at a Findloop partner. If the distance is long, suggest sending it by post instead.",
  "fa.ownerSafety2": "At the hand-over, check the finder's ID.",
  "fa.photoReviewTitle": "A finder sent a photo. Does it look like your item?",
  "fa.photoLooksLike": "Yes, it looks like my item",
  "fa.photoNotMine": "No, this is not my item",
  "fa.photoNotMineConfirm": "The follow-up will be closed on both sides and your listing will stay open for a new finder.",
  "fa.photoLooksLikeDone": "Thanks! The finder will now compare your declaration.",
  "fa.photoNotMineDone": "Report dismissed. Your listing stays open.",
  "fa.ownerPhotoHint": "Only the finder's photo is shown to you. Tell us whether it looks like your item.",
  "fa.ownerReviewingPhoto": "The owner is reviewing your photo",
  "fa.ownerReviewingPhotoText": "You'll be notified as soon as they answer. You'll then be able to compare their declaration.",
  "fa.ownerRejectedPhoto": "This is not the owner's item",
  "fa.ownerRejectedPhotoText": "The owner says your photo does not match their item. The follow-up is closed. Thanks for your help!",
  "fa.contribute": "Contribute",
  "fa.followupClosed": "Follow-up closed",
  "fa.followupClosedText": "You closed this follow-up. Thanks for your help!",
  "fa.closeFollowup": "Close this follow-up",
  "fa.closeFollowupConfirm": "Close this follow-up? Both parties' emails and phone numbers will be permanently deleted once the owner has also closed their listing.",
  "fa.safetyTitle": "Safety tips before the hand-over",
  "fa.safety1": "Ask the owner for a detailed description of hidden features of the item: a specific scratch, the exact contents of a bag, the wallpaper, the serial number…",
  "fa.safety2": "If possible, ask for visual proof (a photo of the item) or proof of purchase.",
  "fa.safety3": "Hand the item over in a public place or at a Findloop partner, and check the owner's ID.",
  "fa.safetyOk": "Got it, continue",
  "fa.ownerClosedNote": "The owner has closed their listing.",
  "fa.finderClosedNote": "The finder has closed their follow-up.",
  "fa.claimSentFinder": "Claim sent to the person who found the item.",
  "fa.compareClaimHint": "Compare the owner's declaration with your listing before deciding.",
  "fa.claimSubV2": "Describe your lost item. The person who found it will compare your declaration with their listing.",
  "fa.photosOptional": "Photos of your item (optional)",
  "fa.compareOwnerHint": "Compare this information with the item you found, then say whether it is the same item.",
  "fa.itsThisItem": "Yes, this is the item",
  "fa.notThisItem": "No, this is not the item",
  "fa.confirmIsItem": "Confirm this is the item? Your contact details and the owner's will be shown in your respective accounts.",
  "fa.confirmNotItem": "Confirm this is not the item? Your report will be closed.",
  "fa.youConfirmed": "You confirmed this is the owner's item",
  "fa.youDeclined": "You indicated this was not the item",
  "fa.youDeclinedText": "Thanks for your help! The owner has been informed.",
  "fa.waitFinderDecisionOwner": "Waiting for the finder's decision",
  "fa.finderConfirmed": "Confirmed",
  "fa.notYourItem": "This was not your item",
  "fa.reportedOn": "Reported on",
  "fa.ownerWaitHint": "A finder is currently checking the information, please wait.",
  "fa.twoPhotosHint": "Personal photos proving the item is yours (with the item, invoice, box…).",
  "fa.sendClaim": "Send my claim",
  "fa.colYourAd": "Your listing",
  "fa.colOwner": "Owner's declaration",
  "fa.approveClaimConfirm": "Approve this claim? The owner will then be able to unlock your contact details.",
  "fa.waitUnlockTitle": "Waiting for the owner to unlock",
  "fa.waitUnlockText": "You'll be notified as soon as contact details are exchanged.",
  "fa.waitClaimantText": "We'll let you know as soon as an owner claims this item.",
  "fa.claimsTitle": "Owner claims",
  "fa.renewed": "Listing renewed",
  "fa.renewTitle": "Renew my listing",
  "fa.renewDiscountBanner": "50% off: renew before your listing expires!",
  "fa.renewBtn": "Renew",
  "fa.renewEarly": "Renew (−50%)",
  "fa.noReceipt": "No receipt available for this listing.",
  "fa.expired": "Listing expired",
  "fa.receipt": "PDF receipt",
  "fa.planTitle": "Listing duration",
  "fa.planSub": "Your listing goes live as soon as payment is confirmed.",
  "fa.days7": "7 days",
  "fa.days30": "30 days",
  "fa.months3": "3 months",
  "fa.hours24": "24 hours",
  "fa.days3": "3 days",
  "fa.ht": "excl. VAT",
  "fa.ttc": "incl. VAT",
  "fa.boostTitle": "Boost my listing (optional)",
  "fa.boostSub": "Your listing stays at the top for the chosen duration.",
  "fa.noBoost": "No boost",
  "fa.total": "Total to pay",
  "fa.payPublish": "Pay and publish",
  "fa.redirectStripe": "Redirecting to secure payment…",
  "fa.publicNote": "Only the description, city, country and photos are shown publicly.",
  "fa.pendingPayTitle": "Payment pending",
  "fa.pendingPayText": "Your listing will go live as soon as payment is confirmed.",
  "fa.finishPay": "Complete payment",
  "fa.waitFinderTitle": "Your listing is live",
  "fa.waitFinderText": "We'll let you know as soon as a finder submits a declaration.",
  "fa.expiresOn": "Expires on",
  "fa.responsesTitle": "Finder declarations",
  "fa.compareHint": "Compare the finder's declaration with yours before deciding.",
  "fa.colYours": "Your declaration",
  "fa.colFinder": "Finder's declaration",
  "fa.fDate": "Date",
  "fa.fPlace": "Place",
  "fa.fCity": "City",
  "fa.fCircumstances": "Circumstances",
  "fa.fColor": "Colour",
  "fa.fCondition": "Condition",
  "fa.fBrand": "Brand",
  "fa.fQuantity": "Quantity",
  "fa.fMessage": "Finder's message",
  "fa.approve": "Approve",
  "fa.reject": "Reject",
  "fa.approveConfirm": "Approve this declaration? Your full contact details (name, email, phone) will be exchanged with the finder.",
  "fa.rejectConfirm": "Reject this declaration? Your listing stays online.",
  "fa.approved": "Declaration approved — contact details exchanged",
  "fa.rejected": "Declaration rejected",
  "fa.finderContact": "Finder's contact details",
  "fa.ownerContact": "Owner's contact details",
  "fa.declTitle": "I found this item",
  "fa.declSub": "Describe the item you found. The owner will compare your declaration with theirs.",
  "fa.foundDate": "Date found",
  "fa.foundPlace": "Place found",
  "fa.contribTitle": "Voluntary contribution",
  "fa.contribSub": "Support Findloop to help more people get their belongings back. You can choose €0.",
  "fa.contribNone": "No contribution",
  "fa.submitDecl": "Send my declaration",
  "fa.submitDeclPay": "Send and contribute {amount}",
  "fa.sent": "Declaration sent to the owner.",
  "fa.waitOwnerTitle": "Waiting for the owner's decision",
  "fa.waitOwnerText": "The owner is comparing your declaration with theirs. You'll be notified of their decision.",
  "fa.approvedFinder": "The owner approved your declaration",
  "fa.approvedFinderText": "Contact them to arrange the return.",
  "fa.rejectedFinder": "It wasn't the item they were looking for",
  "fa.rejectedFinderText": "The owner says this item isn't theirs. Thank you for your help!",
  "fa.contribPaid": "Contribution received — thank you!",
  "fa.contribPending": "Contribution awaiting payment",
  "fa.pubSuccessTitle": "Listing published",
  "fa.pubSuccessMsg": "Your listing is live. You'll be notified as soon as a finder comes forward.",
  "fa.contribSuccessTitle": "Thank you for your contribution",
  "fa.contribSuccessMsg": "Your declaration has been sent to the owner.",
  "fa.waitClaimText": "The finder is reviewing your request. You'll be notified of their decision.",
  "st.pending_payment": "Payment pending",
  "hc.step": "Step",
  "hc.keysForgottenOnABench": "Keys forgotten on a bench",
  "hc.findoPresentationVideo": "Findloop presentation video",
  "hc.theKbisNumberAndVat": "The Kbis number and VAT number are required for France.",
  "hc.country": "Country",
  "hc.phoneOptional": "Phone (optional)",
  "hc.addressStreet": "Address — Street",
  "hc.city": "City",
  "hc.countryAddress": "Country (address)",
  "hc.paymentAlreadyConfirmedByThe": "Payment already confirmed by the partner",
  "hc.itemAlreadyConfirmed": "Item already confirmed",
  "hc.youHaveAlreadyConfirmedThat": "You have already confirmed that this is your item.",
  "hc.reviewTheItemDetails": "Review the item details",
  "hc.shippingPaid": "Shipping paid ✓",
  "hc.payTheShippingFees": "Pay the shipping fees",
  "hc.trackMyRecovery": "Track my recovery",
  "hc.changeMethod": "Change method",
  "hc.waitingForThePartnerS": "Waiting for the partner's confirmation",
  "hc.hasConfirmedYourPaymentYou": "has confirmed your payment, you will be redirected automatically",
  "hc.asSoonAs": "As soon as",
  "hc.toTheShippingFeePayment": "to the shipping fee payment.",
  "hc.toYourRecoveryTracking": "to your recovery tracking.",
  "hc.reopenThePaymentLink": "Reopen the payment link",
  "hc.payTheRecoveryFees": "Pay the recovery fees",
  "hc.itemDetails": "Item details",
  "hc.close": "Close",
  "hc.category": "Category",
  "hc.establishment": "Establishment",
  "hc.brand": "Brand",
  "hc.color": "Color",
  "hc.condition": "Condition",
  "hc.depositedOn": "Deposited on",
  "hc.describeTheItemBrandColor": "Describe the item: brand, color, distinguishing marks… (The more details you give, the better your chances of finding your item)",
  "hc.parisGareDeLyon": "Paris, Gare de Lyon…",
  "hc.payForTheShipmentOf": "Pay for the shipment of your item through Findloop with a secure payment.",
  "hc.yourShippingFeesHaveBeen": "Your shipping fees have been paid. Your parcel is being prepared.",
  "hc.confirmYourShippingAddressTo": "Confirm your shipping address to continue with the payment.",
  "hc.potentialMatchBeingVerified": "Potential match being verified",
  "hc.recoveryOfferedByTheEstablishment": "Recovery offered by the establishment — Findloop charges no fees.",
  "hc.recoveryFeesArePaidDirectly": "Recovery fees are paid directly to the partner establishment. Findloop receives no payment from customers.",
  "hc.awaitingPayment": "Awaiting payment",
  "hc.paymentReceived": "Payment received",
  "hc.labelBeingGenerated": "Label being generated",
  "hc.parcelBeingPrepared": "Parcel being prepared",
  "hc.parcelShipped": "Parcel shipped",
  "hc.parcelDelivered": "Parcel delivered",
  "hc.status": "Status",
  "hc.sharePreview": "Share preview",
  "hc.verifyingTheLink": "Verifying the link…",
  "hc.ownershipConfirmed": "Ownership confirmed",
  "hc.redirectingToTheRecoveryOf": "Redirecting to the recovery of your item…",
  "hc.goToMyAccount": "Go to my account",
  "hc.claimNotFound": "Claim not found",
  "hc.thisValidationLinkIsInvalid": "This validation link is invalid or has expired.",
  "hc.claimApproved": "Claim approved",
  "hc.claimRejected": "Claim rejected",
  "hc.theClaimantHasBeenNotified": "The claimant has been notified and can now proceed with the return.",
  "hc.theClaimantHasBeenInformed": "The claimant has been informed. The item remains available in the public listing.",
  "hc.identityVerification": "Identity verification",
  "hc.theOwnerDescribesTheirItem": "The owner describes their item",
  "hc.aClaimToValidate": "A claim to validate",
  "hc.aUser": "A user",
  "hc.recognizedThePhotoYouSent": "recognized the photo you sent and described these characteristics. Only confirm if they match the item in your possession.",
  "hc.claimsToBeTheOwner": "claims to be the owner of this item and answered the verification questions. Only approve if the answers match.",
  "hc.noAnswerProvided": "No answer provided.",
  "hc.approveTheClaim": "Approve the claim",
  "hc.rejectTheClaim": "Reject the claim",
  "hc.backToHome": "Back to home",
  "hc.isThisReallyYourItem": "Is this really your item?",
  "hc.freeRecoveryAcrossAfricaLaunch": "Free recovery across Africa – Launch offer",
  "hc.checkTheDetailsBeforeContacting": "Check the details before contacting the finder.",
  "hc.yesContactTheFinder": "Yes, contact the finder",
  "hc.thisIsNotMyItem": "This is not my item",
  "hc.paymentSuccessful": "Payment successful!",
  "hc.yourAccountIsActiveYou": "Your account is active, you can now manage your establishments.",
  "hc.yourPaymentHasBeenRecorded": "Your payment has been recorded.",
  "hc.yourShipmentIsBeingPrepared": "Your shipment is being prepared. You will receive your parcel within 3 to 5 business days.",
  "hc.paymentNotCompletedYourAccount": "Payment not completed, your account has not been created — please try again.",
  "hc.verificationSentToThePartner": "Verification sent to the partner. You will be notified of their decision.",
  "hc.declarationNotFound": "Declaration not found.",
  "hc.aNewMatchHasBeen": "A new match has been found",
  "hc.weRanTheAnalysisAgain": "We ran the analysis again and identified another item that could be yours. Please check it again.",
  "hc.checkTheNewItem": "Check the new item",
  "hc.thankYouForYourFeedback": "Thank you for your feedback",
  "hc.weHaveInformedTheEstablishment": "We have informed the establishment that this item is not yours and restarted the analysis. You will be notified as soon as a new match is found.",
  "hc.backToMyAccount": "Back to my account",
  "hc.checkThePhotosAndCharacteristics": "Check the photos and characteristics below before proceeding with the recovery.",
  "hc.noMatchIsAvailableFor": "No match is available for now. We will let you know as soon as an item matches your declaration.",
  "hc.backToPayment": "Back to payment",
  "hc.continueToPayment": "Continue to payment",
  "hc.thisIsMyItemContinue": "This is my item — continue",
  "hc.verificationPending": "Verification pending",
  "hc.theEstablishmentIsReviewingYour": "The establishment is reviewing your answers. You will be notified as soon as your claim is validated, then you can pay the recovery fees.",
  "hc.claimNotValidated": "Claim not validated",
  "hc.theEstablishmentConsideredThatThis": "The establishment considered that this item is not yours.",
  "hc.whyIsThisNotYour": "Why is this not your item?",
  "hc.yourFeedbackHelpsUsRestart": "Your feedback helps us restart the analysis and improve our matches.",
  "hc.cancel": "Cancel",
  "hc.specifyYourReason": "Specify your reason",
  "hc.explainWhyThisItemIs": "Explain why this item is not yours…",
  "hc.sending": "Sending…",
  "hc.send": "Send",
  "hc.secureFindoVerification": "Secure Findloop verification",
  "hc.takenFromYourDeclaration": "taken from your declaration",
  "hc.draftRestoredPickUpYour": "Draft restored — pick up your declaration where you left off.",
  "hc.takeAPhoto": "Take a photo",
  "hc.correctMyDetails": "correct my details",
  "hc.downloadThePdf": "Download the PDF",
  "hc.itemsWhoseLegalDeadlineIs": "Items whose legal deadline is 15 days away or less (overdue included). Matches remain visible.",
  "hc.showOnlyItemsMatchingA": "Show only items matching a public (customer) listing",
  "hc.sortItemsWithAPublic": "Sort: items with a public match (most recent) first",
  "hc.recentMatchesFirst": "Recent matches first",
  "hc.unclaimedItemsMatchLeftWithout": "Unclaimed items: match left without a claim within the deadline. You can put them back in storage.",
  "hc.unclaimedItems": "Unclaimed items",
  "hc.activeMatchWithAPublic": "Active match with a public (customer) listing. Waiting for the owner's claim.",
  "hc.awaitingClaim": "Awaiting claim",
  "hc.unclaimedItemNoClaimWithin": "Unclaimed item — no claim within the deadline.",
  "hc.unclaimed": "Unclaimed",
  "hc.depositCancelledItemRemovedFrom": "Deposit cancelled — item removed from the registry.",
  "hc.depositCancelledItemPutBack": "Deposit cancelled — item put back in stock.",
  "hc.itemPutBackInStorage": "Item put back in storage.",
  "hc.unclaimedItem": "Unclaimed item",
  "hc.putBackInStorage": "Put back in storage",
  "hc.potentialOwner": "Potential owner",
  "hc.customerWhosePublicListingMatches": "Customer whose public listing matches this item — visible only to you.",
  "hc.cancelTheDeposit": "Cancel the deposit",
  "hc.correctThisEntry": "Correct this entry?",
  "hc.yesCancel": "Yes, cancel",
  "hc.no": "No",
  "hc.theItemWillBeRemoved": "The item will be removed from the registry (no claim in progress).",
  "hc.theItemWillBeSet": "The item will be set back to \"in stock\" and the related claim cancelled.",
  "hc.itemWeight": "Item weight:",
  "hc.weightNotProvidedTheShipping": "Weight not provided: the shipping rate will be calculated at the time of shipping.",
  "hc.calculatingTheShippingRate": "Calculating the shipping rate…",
  "hc.reminderDelaySaved": "Reminder delay saved",
  "hc.recoveryPaymentLinkSavedFor": "Recovery payment link saved for this establishment",
  "hc.sendcloudSenderIdSaved": "Sendcloud sender ID saved",
  "hc.recoveryFeesEnabled": "Recovery fees enabled",
  "hc.freeRecoveryFeesDisabled0": "Free recovery: fees disabled (0 €)",
  "hc.defaultCarrierRemoved": "Default carrier removed",
  "hc.emailPreferencesUpdated": "Email preferences updated",
  "hc.establishmentSettings": "Establishment settings",
  "hc.yourEstablishment": "Your establishment",
  "hc.recoveryFees": "Recovery fees",
  "hc.administratorOnly": "Administrator only",
  "hc.whenDisabledFeesDropTo": ". When disabled, fees drop to",
  "hc.andRecoveryIs": "and recovery is",
  "hc.enableOrDisableRecoveryFees": "Enable or disable recovery fees for",
  "hc.feesEnabled": "Fees enabled",
  "hc.freeRecovery0": "Free recovery (0 €)",
  "hc.theCustomerPaysTheFees": "The customer pays the fees to the establishment.",
  "hc.noFeesAreChargedTo": "No fees are charged to the customer.",
  "hc.customerReminderDelay": "Customer reminder delay",
  "hc.ifThePartnerHasNot": "If the partner has not confirmed receipt of the external payment after this delay, Findloop automatically reminds the partner to validate it.",
  "hc.delayHours": "Delay (hours)",
  "hc.defaultCarrier": "Default carrier",
  "hc.automaticallyPreSelected": "automatically pre-selected",
  "hc.forEveryNewShipmentFrom": "for every new shipment from",
  "hc.youCanStillChangeIt": ". You can still change it case by case.",
  "hc.thisCarrierWillBe": "This carrier will be",
  "hc.noneChooseForEachShipment": "None (choose for each shipment)",
  "hc.eGColisPriv": "E.g. Colis Privé",
  "hc.isNotEnabledOnYour": "is not enabled on your Sendcloud account for some destinations. Labels for those will be generated with another available carrier.",
  "hc.none": "none",
  "hc.isAvailableOnSendcloudFor": "is available on Sendcloud for all your routes (domestic + international).",
  "hc.carrierAvailabilityCannotBeChecked": "Carrier availability cannot be checked until your Sendcloud sender is configured.",
  "hc.emailNotificationPreferences": "Email notification preferences",
  "hc.chooseTheLegalRetentionAlerts": "Choose the legal retention alerts received by email for",
  "hc.doesNotHide": "does not hide",
  "hc.theBannerDisplayedInThe": "the banner displayed in the registry.",
  "hc.disablingAnEmail": "Disabling an email",
  "hc.j15EarlyReminder": "D-15 early reminder",
  "hc.15DaysBeforeAnItem": "15 days before an item's legal deadline.",
  "hc.j7EarlyReminder": "D-7 early reminder",
  "hc.7DaysBeforeAnItem": "7 days before an item's legal deadline.",
  "hc.deadlineAlert": "Deadline alert",
  "hc.theDayTheLegalRetention": "The day the legal retention period is reached.",
  "hc.externalPaymentLinks": "External payment links",
  "hc.onlyEachSiteManagesIts": "only. Each site manages its own banking: these links do not affect any other establishment.",
  "hc.linkedTo": "Linked to",
  "hc.leaveTheFieldsEmptyTo": "Leave the fields empty to offer recovery for free.",
  "hc.recoveryPaymentLink": "Recovery payment link",
  "hc.shippingFeesAreHandledAutomatically": "Shipping fees are handled automatically by Findloop (Sendcloud) — no link to enter.",
  "hc.contactFindoToGetYour": "Contact Findloop to get your Sender ID.",
  "hc.findoRegistersTheAddressOf": "Findloop registers the address of your",
  "hc.establishmentInItsSendcloudAccount": "establishment in its Sendcloud account and gives you the sender ID",
  "hc.pasteThisSenderIdIn": "Paste this Sender ID in Findloop → Settings",
  "hc.inTheField": ", in the field",
  "hc.thisStepIsRequiredFor": "This step is required for shipping labels to be generated",
  "hc.automaticallyWhenShipping": "automatically when shipping.",
  "hc.sendcloudSenderIdSenderId": "Sendcloud sender ID (sender_id)",
  "hc.thisFieldIsRequiredFor": "This field is required for automatic label generation.",
  "hc.onlyTheOwnerOrAn": "Only the owner or an administrator can configure the establishment's payment links.",
  "hc.paid": "Paid",
  "hc.failed": "Failed",
  "hc.upcoming": "Upcoming",
  "hc.historyOfYourMonthlySubscriptions": "History of your monthly subscriptions and their payment status.",
  "hc.noInvoiceYet": "No invoice yet.",
  "hc.period": "Period",
  "hc.paidOn": "Paid on",
  "hc.weight": "Weight",
  "hc.weightUnit": "Weight unit",
  "hc.requiredUsedToCalculateThe": "Required: used to calculate the Sendcloud shipping rate. Shipping unavailable above 30 kg.",
  "hc.dimensionsCm": "Dimensions (cm)",
  "hc.optional": "optional",
  "hc.ifProvidedTheVolumetricWeight": "If provided, the volumetric weight is used.",
  "hc.shippingNotAvailableForItems": "Shipping not available for items over 30 kg. The customer will have to collect the item in person.",
  "hc.passedOnToTheCustomer": "— passed on to the customer payment link.",
  "hc.theShippingRateWillBe": "The shipping rate will be calculated automatically via Sendcloud at the time of shipping (recorded weight).",
  "hc.addressSaved": "Address saved",
  "hc.pleaseProvideAReason": "Please provide a reason.",
  "hc.accountDeactivatedAReactivationEmail": "Account deactivated. A reactivation email (valid for 30 days) has been sent to you.",
  "hc.recommended": "Recommended",
  "hc.paymentLinksAreNowConfigured": "Payment links are now configured per establishment",
  "hc.eachSiteManagesItsOwn": "Each site manages its own banking. Go to",
  "hc.settings": "Settings",
  "hc.toConfigureTheLinksAnd": "to configure the links and reminder delay for each establishment.",
  "hc.openSettings": "Open Settings →",
  "hc.streetNo": "Street no.",
  "hc.optional2": "(optional)",
  "hc.streetName": "Street name",
  "hc.mainStreet": "Main Street",
  "hc.deletingDeactivatesYourAccountLogin": "Deleting deactivates your account: login is blocked and data is kept for 30 days. You will receive an email with a reactivation link valid for 30 days.",
  "hc.deleteMyAccount": "Delete my account",
  "hc.helpUsImproveWhyAre": "Help us improve: why are you leaving? Your account will be deactivated and can be reactivated for 30 days.",
  "hc.chooseAReason": "Choose a reason",
  "hc.missingFeatures": "Missing features",
  "hc.iDonTUseIt": "I don't use it enough",
  "hc.anyCommentsOptional": "Any comments? (optional)",
  "hc.tellUsMore": "Tell us more…",
  "hc.confirmDeletion": "Confirm deletion",
  "hc.delivered": "Delivered",
  "hc.shipments": "Shipments",
  "hc.searchByCustomerItemOr": "Search by customer, item or tracking number…",
  "hc.dateNewest": "Date (newest)",
  "hc.dateOldest": "Date (oldest)",
  "hc.noShipmentsYet": "No shipments yet.",
  "hc.item": "Item",
  "hc.date": "Date",
  "hc.noShipmentMatchesYourSearch": "No shipment matches your search.",
  "hc.openTheDeclarationToManage": "Open the declaration to manage the shipment",
  "hc.claimApproved2": "Claim approved.",
  "hc.claimRejected2": "Claim rejected.",
  "hc.aUserClaimsToBe": "A user claims to be the owner. Check their answers before authorizing the return.",
  "hc.yourVerificationQuestionsDeposit": "Your verification questions (deposit)",
  "hc.compareThemWithTheOwner": "Compare them with the owner's answers — never publicly visible.",
  "hc.claimCodeVerified": "Claim code verified",
  "hc.newCodeGeneratedAndSent": "New code generated and sent to the customer by email and SMS",
  "hc.itemMarkedAsReturned": "Item marked as returned ✓",
  "hc.declarationClosed": "Declaration closed ✓",
  "hc.noArchivedDeclarations": "No archived declarations",
  "hc.noDeclarations": "No declarations",
  "hc.processedCasesWillAppearHere": "Processed cases will appear here.",
  "hc.shareYourQrCodeTo": "Share your QR code to receive declarations.",
  "hc.cancelled": "Cancelled",
  "hc.collapse": "Collapse",
  "hc.cancelledByTheCustomer": "Cancelled by the customer",
  "hc.confirmed": "Confirmed ✓",
  "hc.returnSecurity": "Return security",
  "hc.customerClaimCodeToCheck": "Customer claim code — to check at pickup:",
  "hc.codeAlreadyVerified": "Code already verified",
  "hc.claimCodeExpired": "Claim code expired",
  "hc.regenerateTheCode": "Regenerate the code",
  "hc.enterTheCustomerSCode": "Enter the customer's code",
  "hc.verify": "Verify",
  "hc.toCheckBeforeMarkingThe": "To check before marking the item as returned.",
  "hc.comparePhotos": "Compare photos",
  "hc.firstVerifyTheClaimCode": "First verify the claim code above",
  "hc.markAsReturned": "Mark as returned",
  "hc.createTheShipment": "Create the shipment",
  "hc.closeTheDeclaration": "Close the declaration",
  "hc.trackTheShipmentAndDownload": "Track the shipment and download the label (generated automatically) without leaving the Declarations tab.",
  "hc.noShipmentsYet2": "No shipments yet",
  "hc.theShipmentIsCreatedAutomatically": "The shipment is created automatically once the customer has confirmed their address and paid the recovery fees. The label will then be generated automatically after the shipping payment, and can be downloaded here.",
  "hc.closeTheDeclaration2": "Close the declaration?",
  "hc.returned": "returned",
  "hc.andTheDeclarationWillBe": "and the declaration will be closed (moved to history). This action is final.",
  "hc.close2": "Close",
  "hc.limitReachedUpgradeToA": "Limit reached — upgrade to a higher plan",
  "hc.previewOfThePrintReady": "Preview of the print-ready A4 poster for this establishment.",
  "hc.posterPreview": "Poster preview",
  "hc.accountActivatedPleaseLogIn": "Account activated, please log in.",
  "hc.passwordResetPleaseLogIn": "Password reset, please log in.",
  "hc.chooseYourPasswordToAccess": "Choose your password to access the administration console.",
  "hc.accountReactivation": "Account reactivation",
  "hc.reactivating": "Reactivating…",
  "hc.yourAccountHasBeenReactivated": "Your account has been reactivated.",
  "hc.logInToGetBack": "Log in to get back to your space and manage your subscription.",
  "hc.invalidOrExpiredReactivationLink": "Invalid or expired reactivation link",
  "hc.theLinkMayHaveExpired": "The link may have expired (valid for 30 days). Contact Findloop support if needed.",
  "hc.adminFullView": "Admin (full view)",
  "hc.passwordsDoNotMatch": "Passwords do not match.",
  "hc.accountActivation": "Account activation",
  "hc.goToLogin": "Go to login",
  "hc.role": "Role:",
  "hc.establishment2": "Establishment:",
  "hc.password": "Password",
  "hc.atLeast6Characters": "At least 6 characters",
  "hc.confirmPassword": "Confirm password",
  "hc.repeatThePassword": "Repeat the password",
  "hc.accountCreated": "Account created!",
  "hc.redirectingToPayment": "Redirecting to payment…",
  "hc.hotelBelmont": "Hotel Belmont",
  "hc.confirmYourSubscription": "Confirm your subscription",
  "hc.youWillBeRedirectedTo": "You will be redirected to the secure Stripe payment.",
  "hc.selectedPlan": "Selected plan",
  "hc.edit": "Edit",
  "hc.confirmAndPay": "Confirm and pay",
  "hc.youBusinessCom": "you@business.com",
  "hc.reset": "Reset",
  "hc.previousPhoto": "Previous photo",
  "hc.clickToZoom": "Click to zoom",
  "hc.caseClosedThankYou": "Case closed. Thank you!",
  "hc.waitingForPartnerConfirmation": "Waiting for partner confirmation",
  "hc.cancelMyDeclaration": "Cancel my declaration",
  "hc.giveTheReasonForCancelling": "Give the reason for cancelling. The partner will be informed.",
  "hc.verificationSentToTheFinder": "Verification sent to the finder. You will be notified of their decision.",
  "hc.theFinderIsReviewingYour": "The finder is reviewing your claim. You will be notified as soon as it is validated.",
  "hc.theFinderConsideredThatThis": "The finder considered that this item is not yours.",
  "hc.claimValidated": "Claim validated",
  "hc.unlockTheFinderSContact": "Unlock the finder's contact details to arrange the handover.",
  "hc.confirmThatThisIsYour": "Confirm that this is your item. An identity check will be requested from the finder before any contact.",
  "hc.thisIsMyItem": "This is my item",
  "hc.enlargePhoto": "Enlarge photo",
  "hc.reasonSavedYouCanStill": "Reason saved. You can still claim your item.",
  "hc.cancelThisMatch": "Cancel this match",
  "hc.tellUsWhyYourListing": "Tell us why. Your listing remains active and you can still claim your item.",
  "hc.reportDismissedYourListingRemains": "Report dismissed. Your listing remains public.",
  "hc.listingHiddenByModeration": "Listing hidden by moderation.",
  "hc.yourItemHasBeenShipped": "Your item has been shipped by the partner — close the case once delivery is confirmed.",
  "hc.yourItemHasBeenHanded": "Your item has been handed over in person by the partner — close the case once the handover is confirmed.",
  "hc.finderAcceptedCloseTheCase": "Finder accepted — close the case once the item has been handed over in person.",
  "hc.makeSureThisIsThe": "Make sure this is the item you lost before unlocking the finder's contact details.",
  "hc.specifyWhetherYouRecoveredYour": "Specify whether you recovered your item or simply want to remove this listing.",
  "hc.thisMatchIsNoLonger": "This match is no longer available or has already been processed.",
  "hc.weHaveInformedThePartner": "We have informed the partner that this item is not yours. Your listing remains active for future matches.",
  "hc.itemFoundAtAPartner": "Item found at a partner",
  "hc.isThisYourItem": "Is this your item?",
  "hc.checkTheDetailsBelowBefore": "Check the details below before starting your return request.",
  "hc.claimValidatedByThePartner": "Claim validated by the partner",
  "hc.youCanNowStartThe": "You can now start the return.",
  "hc.continueTheReturn": "Continue the return",
  "hc.thePartnerIsReviewingYour": "The partner is reviewing your answers. You will be notified as soon as your claim is validated.",
  "hc.thePartnerConsideredThatThis": "The partner considered that this item is not yours. The item remains available.",
  "hc.thisIsMyItemStart": "This is my item — start the return",
  "hc.yourFeedbackHelpsUsImprove": "Your feedback helps us improve our matches.",
  "hc.hidePassword": "Hide password",
  "hc.showPassword": "Show password",
  "hc.carrierSelection": "Carrier selection",
  "hc.shippingFeesHaveAlreadyBeen": "Shipping fees have already been paid: the carrier can no longer be changed.",
  "hc.simulatedRatesInPreProduction": "(simulated rates in pre-production)",
  "hc.rateChargedToTheCustomer": "Rate charged to the customer:",
  "hc.thisRateWillBeCharged": "This rate will be charged to the customer. A high rate may discourage recovery.",
  "hc.confirmTheCarrier": "Confirm the carrier",
  "hc.beforeAfterComparisonSlider": "Before/after comparison slider",
  "hc.theLabelIsGeneratedAutomatically": "The label is generated automatically as soon as the customer has paid the shipping fees. It will be downloadable here.",
  "hc.adjustThePhoto": "Adjust the photo",
  "hc.dragToReposition": "Drag to reposition",
  "hc.fullPhoto": "Full photo",
  "hc.confirmCrop": "Confirm crop",
  "hc.stopScrolling": "Stop scrolling",
  "hc.scrollThroughLanguages": "Scroll through languages",
  "hc.declarationNotFound2": "Declaration not found",
  "hc.pleaseCompleteYourShippingAddress": "Please complete your shipping address.",
  "hc.pleaseProvideAPhoneNumber": "Please provide a phone number: it is required by the carrier for shipping.",
  "hc.invalidNumberEnterAnInternational": "Invalid number. Enter an international number, e.g. +33 6 12 34 56 78.",
  "hc.yourShippingFeesHaveAlready": "Your shipping fees have already been paid. Shipping paid ✓",
  "hc.unableToOpenTheShipping": "Unable to open the shipping fee payment. Please try again.",
  "hc.shippingAddress": "Shipping address",
  "hc.checkOrEditYourDetails": "Check or edit your details before the secure payment.",
  "hc.fullName": "Full name",
  "hc.phoneNumber": "Phone number",
  "hc.iFoundItElsewhere": "I found it elsewhere",
  "hc.theFeesAreTooHigh": "The fees are too high",
  "hc.iNoLongerNeedMy": "I no longer need my item",
  "hc.specifyYourReason2": "Specify your reason…",
  "hc.back": "Back",
  "hc.signInTheBoxAbove": "Sign in the box above",
  "hc.signatureSaved": "Signature saved",
  "hc.findoCityRanking": "Findloop — City ranking",
  "hc.toReachOurFirstMilestone": "to reach our first milestone of 100 returns.",
  "hc.only": "Only",
  "hc.high": "High",
  "hc.platformReturnTarget": "Platform return target",
  "hc.targetReachedThankYouTo": "Target reached — thank you to the whole Findloop community!",
  "hc.overallRateTrendLast6": "Overall rate trend (last 6 months)",
  "hc.topCitiesForReturns": "Top cities for returns",
  "hc.shareTheRanking": "Share the ranking",
  "hc.impersonationSessionExpired": "Impersonation session expired.",
  "hc.impersonationEnded": "Impersonation ended.",
  "hc.signedInWithGoogle": "Signed in with Google",
  "hc.viewInRegistry": "View in registry",
  "hc.viewItem": "View item",
  "hc.sessionExpired": "Session expired",
  "hc.stillThere": "Still there?",
  "hc.staySignedIn": "Stay signed in",
  "hc.termsAndPolicies": "Terms and policies",
  "hc.termsAndConditions": "Terms and conditions",
  "hc.privacyPolicy": "Privacy policy",
  "hc.legalNotice": "Legal notice",
  "hc.contactUs": "Contact us",
  "hc.addOnGoogle": "Add on Google",
  "hc.manageCookies": "Manage cookies",
  "hc.previous": "Previous",
  "hc.next": "Next",
  "hc.newCodeGeneratedAndSent2": "New code generated and sent to the owner",
  "hc.itemPhotoSaved": "Item photo saved",
  "hc.questionsToAskTheOwner": "Questions to ask the owner",
  "hc.askThemAtTheCounter": "Ask them at the counter to confirm identity — never publicly visible.",
  "hc.regenerateAndResendToThe": "Regenerate and resend to the owner",
  "hc.ownerSClaimCode": "Owner's claim code",
  "hc.scanTheOwnerSQr": "Scan the owner's QR",
  "hc.theOwnerReceivedItBy": "The owner received it by email (or SMS). Enter or scan it before the handover.",
  "hc.originalListingPhotoUsed": "Original listing photo used",
  "hc.preFilledAutomaticallyYouCan": "Pre-filled automatically — you can replace it with a photo of the parcel.",
  "hc.itemPreview": "Item preview",
  "hc.takeChangeThePhoto": "Take / change the photo",
  "hc.itemPhotoRequiredBeforeShipping": "Item photo (required before shipping)",
  "hc.addAPhoto": "Add a photo",
  "hc.visibleToTheOwnerAutomatically": "Visible to the owner · automatically deleted after 60 days.",
  "hc.proofOfReturnPdf": "Proof of return (PDF)",
  "hc.scanTheClaimCode": "Scan the claim code",
  "hc.cameraUnavailableEnterTheCode": "Camera unavailable. Enter the code manually.",
  "hc.askTheOwnerToDisplay": "Ask the owner to display their code's QR (tracking page).",
  "hc.registerAFoundItem": "Register a found item",
  "hc.openDepositInTheMenu": "Open \"Deposit\" in the menu, describe the item and take a photo. It is immediately stored and ready to be returned.",
  "hc.storeFindWithQr": "Store & find with QR",
  "hc.eachItemGetsAQr": "Each item gets a QR label. Scan it from \"Storage & QR\" to locate an item in an instant.",
  "hc.returnToTheOwner": "Return to the owner",
  "hc.whenACustomerComesTo": "When a customer comes to collect their belongings, open their declaration and validate the return. That's it!",
  "hc.manageYourTeam": "Manage your team",
  "hc.fromTeamInviteYourColleagues": "From \"Team\", invite your colleagues by email and assign them an establishment. Each member only sees their own scope.",
  "hc.setUpYourEstablishments": "Set up your establishments",
  "hc.addAndConfigureYourEstablishments": "Add and configure your establishments in \"Establishments\": contact details, category and physical storage of items.",
  "hc.trackYourStatistics": "Track your statistics",
  "hc.checkStatisticsToTrackDeposited": "Check \"Statistics\" to track deposited items, return rate and performance of each establishment.",
  "hc.manageMyTeam": "Manage my team",
  "hc.depositAnItem": "Deposit an item",
  "hc.yourFirstStepsAdmin": "Your first steps (admin)",
  "hc.yourFirstSteps": "Your first steps",
  "hc.privacy": "Privacy",
  "hc.cropThePhoto": "Crop the photo",
  "hc.moveThePhotoToFit": "Move the photo to fit it in the circle.",
  "hc.save": "Save",
  "hc.8CharactersMinimum": "8 characters minimum.",
  "hc.passwordUpdated": "Password updated.",
  "hc.chooseANewPassword": "Choose a new password",
  "hc.pleaseSetYourOwnPassword": "please set your own password before continuing.",
  "hc.newPassword": "New password",
  "hc.confirmThePassword": "Confirm the password",
  "hc.saveAndContinue": "Save and continue",
  "hc.billingInformationSaved": "Billing information saved ✓",
  "hc.unableToRetrieveTheInvoice": "Unable to retrieve the invoice.",
  "hc.billingInformation": "Billing information",
  "hc.siretAndVatNumberRequired": "SIRET and VAT number required (France).",
  "hc.intraEuVatNumberOptional": "Intra-EU VAT number optional, no SIRET required (outside France).",
  "hc.countryIsoCodeEG": "Country (ISO code, e.g. FR)",
  "hc.address": "Address",
  "hc.optional3": "optional",
  "hc.noInvoiceYetYourInvoices": "No invoice yet. Your invoices will appear here automatically after each payment.",
  "hc.assistanceSessionRevoked": "Assistance session revoked.",
  "hc.aFindoAssistanceSessionIs": "A Findloop assistance session is currently active on your account.",
  "hc.revokeAccess": "Revoke access",
  "hc.chooseACountry": "Choose a country",
  "hc.searchForACountry": "Search for a country…",
  "hc.noCountryFound": "No country found",
  "hc.other": "Other",
  "hc.cancellationReason": "Cancellation reason",
  "hc.tellUsWhyYouCancel": "Tell us why you are cancelling. This helps the partner process your request.",
  "hc.welcomeToFindo": "Welcome to Findloop",
  "hc.skip": "Skip",
  "hc.company": "Company",
  "hc.aboutFindo": "About Findloop",
  "hc.careers": "Careers",
  "hc.pressKit": "Press kit",
  "hc.ourProducts": "Our products",
  "hc.findoForEstablishments": "Findloop for establishments",
  "hc.partnerDirectory": "Partner directory",
  "hc.declarationTracking": "Declaration tracking",
  "hc.shipping": "Shipping",
  "hc.assistance": "Support",
  "hc.helpCenter": "Help center",
  "hc.reportAProblem": "Report a problem",
  "hc.lostFoundPlatform": "Lost & found platform.",
  "hc.pending": "Pending",
  "hc.inTransit": "In transit",
  "hc.staff": "Staff",
  "ac.emailCrossReject": "Public match rejections",
  "ac.emailCrossRejectDesc": "Receive an email when a customer indicates that a suggested public match is not their item.",
  "ac.emailLoginNotif": "Login notification",
  "ac.emailLoginNotifDesc": "Receive an email each time someone logs into your account.",
  "an.qfAll": "All",
  "an.qfBoosted": "Boosted",
  "an.qfPhoto": "With photo",
  "an.qfRecent": "This week",
  "an.qfResolved": "Resolved",
  "dec.loadError": "Unable to load the partner right now. Check your connection and try again.",
  "dec.retry": "Retry",
  "ft.cancelConfirm": "Cancel your report? The item's owner will be informed.",
  "ft.cancelDone": "Report cancelled.",
  "ft.cancelReport": "Cancel my report",
  "map.objectsOnMapPlural": "items on the map",
  "map.objectsOnMapSingular": "item on the map",
  "mc2.cancelDecl": "Cancel my declaration",
  "mc2.cancelDeclDone": "Declaration cancelled.",
  "shp.labelAuto": "The label is generated automatically as soon as the customer has paid the shipping fees. It will be downloadable here.",
  "stt.dispoPdfBtn": "Export PDF",
  "stt.dispoPdfError": "PDF export failed.",
  "stt.dispoPdfExporting": "Exporting…",
  "hc.africa": "Africa",
  "hc.payment": "Payment",
  "hc.locateMe": "Locate me",
  "hc.linkUnavailable": "Link unavailable",
  "hc.myAccount": "My account",
  "hc.loading": "Loading…",
  "hc.annualTarget": "Annual target",
  "hc.reached": "reached",
  "hc.resumeRegistration": "Resume registration",
  "hc.clear": "Clear",
  "hc.gallery": "Gallery",
  "hc.invalidSendcloudId": "Invalid Sendcloud ID",
  "hc.free": "free",
  "hc.toTheCustomer": "to the customer.",
  "hc.carrier": "Carrier",
  "hc.other2": "Other…",
  "hc.carrierOther": "Carrier (other)",
  "hc.field": ") field.",
  "hc.save2": "save",
  "hc.myMonthlyInvoices": "My monthly invoices",
  "hc.amount": "Amount",
  "hc.pdfInvoice": "PDF invoice",
  "hc.annual20": "Annual -20%",
  "hc.monthly": "Monthly",
  "hc.cover": "cover",
  "hc.mainReason": "Main reason",
  "hc.tooExpensiveBudget": "Too expensive / budget",
  "hc.all": "All",
  "hc.tracking": "Tracking",
  "hc.aiVisualComparison": "AI visual comparison",
  "hc.analyzing": "Analyzing…",
  "hc.printThePoster": "Print the poster",
  "hc.activateMyAdminAccount": "Activate my admin account",
  "hc.activateMyAccount": "Activate my account",
  "hc.logIn": "Log in",
  "hc.invalidInvitationLink": "Invalid invitation link.",
  "hc.invalidInvitationLink2": "Invalid invitation link",
  "hc.copy": "Copy",
  "hc.annualBilling20": "Annual billing (−20%)",
  "hc.monthlyBilling": "Monthly billing",
  "hc.welcome": "Welcome!",
  "hc.nextPhoto": "Next photo",
  "hc.resume": "Resume",
  "hc.matchNotFound": "Match not found",
  "hc.partner": "Partner",
  "hc.switchToLightMode": "Switch to light mode",
  "hc.switchToDarkMode": "Switch to dark mode",
  "hc.selectedCarrier": "Selected carrier:",
  "hc.exit": "Exit",
  "hc.confirmCancellation": "Confirm cancellation",
  "hc.lowRate": "Low rate",
  "hc.medium": "Medium",
  "hc.partner2": "partner",
  "hc.saving": "Saving…",
  "hc.companyName": "Company name",
  "hc.14Digits": "14 digits",
  "hc.myInvoices": "My invoices",
  "hc.bronze": "Bronze",
  "hc.silver": "Silver",
  "hc.gold": "Gold",
  "hc.previewMode": "Preview mode:",
  "hc.thisEstablishment": "this establishment",
  "hc.linkCopiedShareOn": "Link copied — share it on {label}",
  "hc.findoReviewShare": "Findloop {year} review: {n} items returned, {rate}% return rate 🎉",
  "hc.retro": "Year in review",
  "hc.lostIn": "lost in",
  "hc.activeMatchCancelReason": "Active match. Customer's cancellation reason: \"{reason}\". The item is still awaiting a claim.",
  "hc.unclaimedCustomerReason": "Unclaimed item. Customer's reason: \"{reason}\".",
  "hc.archiveCancelledConfirm": "Archive {n} listing(s) \"Cancelled by the customer\"? They will be removed from the registry.",
  "hc.nArchived": "{n} listing(s) archived.",
  "hc.inviteSubtitle": "{org} invites you to join their Findloop team. Choose your password to activate your account.",
  "hc.anOrganization": "An organization",
  "hc.codeCopied": "Code copied",
  "hc.carrierConfirmedCharged": "Carrier confirmed — {price} € charged to the customer",
  "hc.itemsReturned": "item(s) returned",
  "hc.targetReached": "Target reached",
  "hc.target": "Target",
  "hc.pointsToGoal": "{n} more points to reach our shared goal.",
  "hc.idleLogoutIn": "You will be logged out in {n} s due to inactivity.",
  "hc.d15": "D-15",
  "hc.publicMatch": "Public match",
  "hc.primary": "primary",
  "hc.dangerZone": "Danger zone",
  "hc.deleting": "Deleting…",
  "hc.customer": "Customer",
  "hc.inclVat": "incl. VAT",
  "hc.impersonationMode": "Impersonation mode",
  "hc.b2cCustomer": "B2C customer",
  "hc.exId": "e.g. 3f2a…",
  "hc.exCode": "e.g. ABCD2345",
  "hc.shareLostText": "I lost an item — help me find it on Findloop",
  "hc.shareFoundText": "I found an item — help me find its owner on Findloop",
  "hc.smsSentIfAccount": "If an account exists with this number, an SMS has been sent to you.",
  "hc.paidViaPartner": "Paid (via partner)",
  "hc.youAreHere": "You are here",
  "hc.invalidOrExpiredLink": "Invalid or expired link.",
  "hc.characteristic": "Characteristic",
  "hc.rateOfTarget": "{rate}% achieved out of a {target}% target",
  "hc.itemFoundAt": "Item found at",
  "hc.matchNoClaimInTime": "The match received no claim within the deadline.",
  "hc.customerReasonFmt": "Customer's reason: \"{reason}\".",
  "hc.shipRateForWeight": "Shipping rate (Sendcloud + {m}% margin) for {w}:",
  "hc.shipRateAutoWeight": "The shipping rate is calculated automatically via Sendcloud (weight {w}) at the time of shipping.",
  "hc.settingsSubtitle": "External payments and reminders, configured per establishment.",
  "hc.howConfigureSenderId": "How do I set up my numeric Sender ID?",
  "hc.estShipRate": "Estimated shipping rate (Sendcloud + {m}% margin):",
  "hc.shipmentsSubtitle": "Consolidated view of all the establishment's shipments, across all cases. Click a row to manage the shipment in its declaration.",
  "hc.claimsToValidate": "Claims to validate",
  "hc.claimant": "Claimant",
  "hc.theItem": "The item",
  "hc.of": "of",
  "hc.willBeMarkedAs": "will be marked as",
  "hc.planLimitFmt": "Your \"{plan}\" plan is limited to {max} establishment. To manage {n} sites, we recommend the",
  "hc.planAt": "plan at",
  "hc.switchTo": "Switch to",
  "hc.invalidInviteLink": "Invalid or expired invitation link.",
  "hc.verifyingInvite": "Verifying the invitation link…",
  "hc.activating": "Activating…",
  "hc.signupFailed": "Sign-up failed",
  "hc.cannotOpenPayment": "Unable to open the payment. Please try again.",
  "hc.redirecting": "Redirecting…",
  "hc.loginFailed": "Login failed",
  "hc.kbisNumber": "Kbis number",
  "hc.vatNumber": "VAT number",
  "hc.cancelSavedFmt": "Cancellation saved: \"{reason}\". You can still claim.",
  "hc.viewItemRecover": "View item & recover",
  "hc.defaultCarrierPreselected": "Default carrier pre-selected — can be changed for this shipment. Actual rate (Sendcloud + {m}% margin).",
  "hc.chargedToCustomer": "charged to the customer.",
  "hc.milestoneFmt": "{m} returned items milestone reached! On the way to {next}.",
  "hc.itemsReturnedThisYear": "items returned this year",
  "hc.daysToYearEnd": "{n} days until the end of the year",
  "hc.seeRetro": "See the year in review",
  "hc.googleLoginFailed": "Google sign-in failed",
  "hc.protectedByRecaptcha": "Protected by reCAPTCHA",
  "hc.updateFailed": "Update failed.",
  "hc.pwdResetByTeam": "Your password was reset by our team. For your security,",
  "hc.usedForInvoices": "Used to issue your Findloop invoices.",
  "hc.download": "Download",
  "hc.wrongColor": "Wrong color",
  "hc.wrongModel": "Wrong model",
  "hc.notMine": "It's not mine",
  "hc.saveBtn": "Save",
  "hc.saveLink": "Save link",
  "hc.view": "View",
  "pcat.airport": "Airport",
  "pcat.travel_agency": "Travel agency",
  "pcat.bank": "Bank",
  "pcat.bar_cafe": "Bar / Café",
  "pcat.library": "Library",
  "pcat.mall": "Shopping mall",
  "pcat.sports_center": "Sports center",
  "pcat.cinema": "Cinema",
  "pcat.airline": "Airline",
  "pcat.school_university": "School / University",
  "pcat.private_company": "Private company",
  "pcat.coworking": "Coworking space",
  "pcat.train_bus_station": "Train / bus station",
  "pcat.hospital_clinic": "Hospital / Clinic",
  "pcat.museum": "Museum",
  "pcat.tourism_office": "Tourist office",
  "pcat.amusement_park": "Amusement park",
  "pcat.pharmacy": "Pharmacy",
  "pcat.concert_theater": "Concert hall / Theater",
  "pcat.gym_fitness": "Gym / Fitness",
  "pcat.beauty_salon": "Hair / Beauty salon",
  "pcat.stadium_arena": "Stadium / Arena",
  "pcat.supermarket": "Supermarket",
  "pcat.taxi_vtc": "Taxi / Ride-hailing",
  "pcat.public_transport": "Public transport",
  "hc.and": "and",
  "hc.terms": "Terms",
  "hc.feedReal": "An item ({cat}) was returned in {city}.",
  "hc.feedDemo": "{obj} was returned in {city} {when}.",
  "hc.demoObj0": "a wallet",
  "hc.demoObj1": "a sports bag",
  "hc.demoObj2": "a phone",
  "hc.demoObj3": "a pair of glasses",
  "hc.demoObj4": "a set of keys",
  "hc.demoObj5": "a scarf",
  "hc.demoObj6": "a laptop",
  "hc.demoObj7": "a water bottle",
  "hc.demoWhen0": "2 hours ago",
  "hc.demoWhen1": "5 hours ago",
  "hc.demoWhen2": "yesterday",
  "hc.demoWhen3": "3 hours ago",
  "hc.demoWhen4": "this morning",
  "hc.demoWhen5": "1 day ago",
  "hc.shareReview": "Share the review",
  "an.found": "Found",
  "an.lost": "Lost",
  "hc.citiesAboveTarget": "{n} cities above their target",
  "hc.cityAboveTarget": "{n} city above its target",
  "hc.monthlyPrice": "Monthly price",
  "hc.perMonth": "/ month",
  "hc.perYear": "/ year",
  "hc.annualTotal": "Annual total",
  "hc.billedOnceYear": "Charged once for 12 months, renewed every year.",
  "hc.billedEachMonth": "Charged automatically every month.",
  "nav.individual": "Individual",
  "nav.business": "Business",
  "hc.firstName": "First name",
  "hc.lastName": "Last name",
  "hc.quantity": "Number of items",
  "hc.circumstancesLost": "Circumstances of the loss",
  "hc.circumstancesFound": "Circumstances of the find",
  "hc.circumstancesLostPh": "E.g. left on a bench while waiting for the bus",
  "hc.circumstancesFoundPh": "E.g. found on the ground near the metro entrance",
  "hc.conditionPh": "E.g. good, scratched…"
 }
};
